import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  GetAllCustomersName,
  GetProductByIdSale,
  AddSaleOrderApi,
  getProductFilterSubString,
  getAccNamesAssetCash,
  GetTaxByStoreId,
  CheckCusNameExist,
  AddCustomerApi,
  AddSpecialOrder,
  getAllVendorsNameByPurchaseProduct,
  GetAllCustomerTypes,
  GetSaleOrderCustomerByID,
  GetSaleOrderDetailsByID,
  getProductsAddSOOffline,
  GetUnitByProductId,
  GetGenerateInvoice,
} from "../../api";
import Select from "react-select";
import { useStateContext } from "../../contexts/ContextProvider";
import "../../styles/sale.css";
import { Card } from "react-bootstrap";
import "../../styles/viewCustomer.css";
import { Col, Container, Row } from "react-bootstrap";
import { Header } from "../../components";
import {
  validateEmail,
  validateName,
  ValidPhone,
  ValidOrderField,
  ValidWebsite,
  ValidText,
} from "../../contexts/Utils";
import idbApi from "../../api/IdbApi";
import {
  ACCOUNTREC_TBL,
  CUSTOMER_TBL,
  PENDSALES_TBL,
  PRODUCT_TBL,
} from "../../contexts/IndexedDB";
import { useOnlineStatus } from "../../contexts/OnlineStatus";
import { generateInvoice } from "../../contexts/SaleInv";

const AddSaleOrder = () => {
  const {
    currentColor,
    defaultImageMode,
    imageMode,
    setActiveProdMenu,
    setActiveProdMenuId,
    fiscalYear,
    userID,
    storeG,
    userToken,
    userName,
    orgName,
  } = useStateContext();
  const online = useOnlineStatus();
  const [GetCustomer, setGetCustomer] = useState([]);
  const [ProductStr, setProductStr] = useState("");
  const [CustomerOptions, setCustomerOptions] = useState([]);
  const [product, setProducts] = useState("");
  const [unitPrice, setUnitPrice] = useState(0);
  const [qty, setqty] = useState(1.0);
  const [productOptions, setProductOptions] = useState([]);
  const [productOffline, setProductOffline] = useState([]);
  const [p_code, setp_code] = useState("");
  const [customer_ids, setcustomer_ids] = useState("");
  const [CardList, setcartList] = useState([]);
  const [total_amount, settotalAmount] = useState(0.0);
  const [tax, settax] = useState(0.0);
  const [totaldiscount, settotaldiscount] = useState(0.0);
  const [total_item, settotalitem] = useState(0.0);
  const [index1, setindex1] = useState("");
  const [grandtotal, setgrandtotal] = useState(0.0);
  const [note, setnote] = useState("");
  const [trackingno, settrackingno] = useState("");
  const [projectname, setprojectname] = useState("");
  const [projectname1, setprojectname1] = useState("");
  const [projectname2, setprojectname2] = useState(0);
  const [shipmethod, setshipmethod] = useState("");
  const [OrderStatus, setOrderStatus] = useState("MARK AS OPEN");
  const [orderstatuslable, setorderstatuslable] = useState("CLOSE");
  const [ValError, setValError] = useState([]);
  const [acc_to, setacc_to] = useState("");
  const [getacc_tos, setGetacc_tos] = useState([]);
  const [allAccTo, setAllAccTo] = useState([]);
  const [amount_paid, setamount_paid] = useState(0);
  const [amount_pend, setamount_pend] = useState(0);
  const [acc_to_id, setacc_to_id] = useState("");
  const [acc_to_bal, setacc_to_bal] = useState("");
  const [acc_from_id, setacc_from_id] = useState("");
  const [acc_from_bal, setacc_from_bal] = useState("");
  const [ActiveProduct, setActiveProduct] = useState(0);
  const [advancedMode, setAdvancedMode] = useState(0);
  const [fullShipping, setFullShipping] = useState(1);
  const [name, setname] = useState("");
  const [getcType, setGetcType] = useState([]);
  const [cType, setcType] = useState("select");
  const [c_type_id, setc_type_id] = useState("");
  const [dot, setdot] = useState(0);
  const [isPageFrozen, setIsPageFrozen] = useState(false);
  const [saveClick, setsaveClick] = useState(false);
  const [print_flag, setprint_flag] = useState(false);
  //const [productID, setproductID] = useState("");
  //const [toggle, setToggle] = useState(false);

  let param = useParams();
  const [store_id, setStore_id] = useState(param.store_id);
  const [dup, setDup] = useState("");

  const [formData, setFormData] = useState({
    est_sale: "S",
    customer_id: 0,
    customer_po_no: "",
    project_name: "",
    ship_method: "",
    tracking_no: "",
    total: 0,
    amount_paid: 0,
    amount_pending: 0,
    user_id: null,
    so_note: "",
    total_price: 0,
    discount: 0,
    tax: 0,
    status_id: 80,
    shipment: 0,
    store_id: 0,
    t_type_id: 700,
    o_datetime: "",
    sale_products: [],
    shipments: [],
  });

  const keypadButtons = [
    "7",
    "8",
    "9",
    "4",
    "5",
    "6",
    "1",
    "2",
    "3",
    ".",
    "0",
    "00",
  ];

  const [activeInput, setActiveInput] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [defaultCustomer, setDefaultCustomer] = useState(null);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [supplier_ids, setsupplier_ids] = useState("");
  const [supplier_name, setsupplier_name] = useState("-");
  const [SupplierOptions, setSupplierOptions] = useState([]);
  const [GetSupplier, setGetSupplier] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [UnitOptions, setUnitOptions] = useState([]);
  const [GetUnit, setGetUnit] = useState([]);
  const [oDatetime, setODatetime] = useState("");
  const [oMinDatetime, setOMinDatetime] = useState("");
  const [oMaxDatetime, setOMaxDatetime] = useState("");
  const [dTNow, setDTNow] = useState(1);

  const handleInputClick = (inputId, index) => {
    TimeoutUtility.resetTimeout();
    setActiveInput(inputId);
    setindex1(index);
  };

  const handleChangeDTNow = () => {
    var now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    setODatetime(now.toISOString().slice(0, 19));

    if (dTNow === 1) {
      setOMaxDatetime(now.toISOString().slice(0, 19));
      now = new Date(fiscalYear, 0, 1);
      now.setUTCHours(24);
      setOMinDatetime(now.toISOString().slice(0, 19));
    }
    setDTNow((prev) => (prev === 0 ? 1 : 0));
  };

  const handleChangeODateTime = (e) => {
    if (e === "undefined") {
      setODatetime(null);
    } else {
      if (new Date(e) > new Date(oMinDatetime)) {
        setODatetime(e);
      }
    }
  };

  const handleChangeReqDate = (index, e) => {
    const newCartList = [...CardList];
    if (e === "undefined") {
      newCartList[index].req_delivery_date = "";
    } else {
      newCartList[index].req_delivery_date = e;
    }
    setcartList(newCartList);
  };

  const handleShipmentClick = (inputId, index) => {
    TimeoutUtility.resetTimeout();
    setActiveInput(inputId);
    setindex1(index);
  };

  const handleSpecQtyClick = (inputId, index) => {
    TimeoutUtility.resetTimeout();
    setActiveInput(inputId);
    setindex1(index);
  };

  const handleKeypadClick = (value) => {
    TimeoutUtility.resetTimeout();
    // try {
    if (activeInput !== null) {
      const newCartList = [...CardList];
      const indexToUpdate = index1;
      var newValue = "0";
      if (
        activeInput === "quantity" ||
        activeInput === "unit_price" ||
        activeInput === "discount" ||
        activeInput === "shipment" ||
        activeInput === "spec_qty"
      ) {
        var currentValue = String(
          newCartList[indexToUpdate][activeInput] || ""
        );
        if (value === "." && currentValue.includes(".")) {
          return;
        }
        if (value === "." && !currentValue.includes(".")) {
          if (currentValue === "") {
            currentValue = "0";
          }
          newCartList[indexToUpdate][activeInput] = currentValue + ".0";
          setcartList(newCartList);
          setdot(1);
          return;
        }
        newValue = currentValue + String(value);
        if (dot === 1) {
          var [integerPart] = currentValue.split(".");
          if (integerPart === "") {
            integerPart = "0";
          }
          newValue = integerPart + "." + value;
          setdot(0);
        }
        if (!isNaN(newValue)) {
          newCartList[indexToUpdate][activeInput] = newValue;
          newCartList[indexToUpdate].total =
            (newCartList[indexToUpdate].unit_price -
              newCartList[indexToUpdate].discount) *
            newCartList[indexToUpdate].quantity;
          setcartList(newCartList);
          setdot(0);
        }
      } else if (activeInput === "tax" && index1 === -2) {
        var currentTaxValue = String(tax || "");

        if (value === "." && currentTaxValue.includes(".")) {
          return;
        }
        if (value === "." && !currentTaxValue.includes(".")) {
          if (currentTaxValue === "") {
            currentTaxValue = "0";
          }
          settax(currentTaxValue + ".0");
          setdot(1);
          return;
        }
        newValue = currentTaxValue + String(value || "");
        if (dot === 1) {
          var [integerPart0] = currentTaxValue.split(".");
          if (integerPart0 === "") {
            integerPart0 = "0";
          }
          newValue = integerPart0 + "." + value;
          setdot(0);
        }
        if (!isNaN(newValue)) {
          settax(newValue);
        }
      } else if (activeInput === "shipment1" && index1 === -3) {
        var currentShipmentValue = String(projectname2 || "");

        if (value === "." && currentShipmentValue.includes(".")) {
          return;
        }
        if (value === "." && !currentShipmentValue.includes(".")) {
          if (currentShipmentValue === "") {
            currentShipmentValue = "0";
          }
          setprojectname2(currentShipmentValue + ".0");
          setdot(1);
          return;
        }
        newValue = currentShipmentValue + String(value || "");
        if (dot === 1) {
          var [integerPart1] = currentShipmentValue.split(".");
          if (integerPart1 === "") {
            integerPart1 = "0";
          }
          newValue = integerPart1 + "." + value;
          setdot(0);
        }
        if (!isNaN(newValue)) {
          setprojectname2(newValue);
        }
      } else if (activeInput === "amount_paid" && index1 === -4) {
        var currentAmtPaidValue = String(amount_paid || "");

        if (value === "." && currentAmtPaidValue.includes(".")) {
          return;
        }
        if (value === "." && !currentAmtPaidValue.includes(".")) {
          if (currentAmtPaidValue === "") {
            currentAmtPaidValue = "0";
          }
          setamount_paid(currentAmtPaidValue + ".0");
          setdot(1);
          return;
        }
        newValue = currentAmtPaidValue + String(value || "");
        if (dot === 1) {
          var [integerPart2] = currentAmtPaidValue.split(".");
          if (integerPart2 === "") {
            integerPart2 = "0";
          }
          newValue = integerPart2 + "." + value;
          setdot(0);
        }
        if (!isNaN(newValue)) {
          setamount_paid(newValue);
          setamount_pend(grandtotal - newValue);
        }
      } else if (activeInput === "qty" && index1 === -8) {
        var currentQtyValue = String(qty || "");

        if (value === "." && currentQtyValue.includes(".")) {
          return;
        }
        if (value === "." && !currentQtyValue.includes(".")) {
          if (currentQtyValue === "") {
            currentQtyValue = "0";
          }
          setqty(currentQtyValue + ".0");
          setdot(1);
          return;
        }
        newValue = currentQtyValue + String(value || "");
        if (dot === 1) {
          var [integerPart3] = currentQtyValue.split(".");
          if (integerPart3 === "") {
            integerPart3 = "0";
          }
          newValue = integerPart3 + "." + value;
          setdot(0);
        }
        if (!isNaN(newValue)) {
          setqty(newValue);
        }
      } else if (activeInput === "uprice" && index1 === -9) {
        var currentUPValue = String(unitPrice || "");

        if (value === "." && currentUPValue.includes(".")) {
          return;
        }
        if (value === "." && !currentUPValue.includes(".")) {
          if (currentUPValue === "") {
            currentUPValue = "0";
          }
          setUnitPrice(currentUPValue + ".0");
          setdot(1);
          return;
        }
        newValue = currentUPValue + String(value || "");
        if (dot === 1) {
          var [integerPart4] = currentUPValue.split(".");
          if (integerPart4 === "") {
            integerPart4 = "0";
          }
          newValue = integerPart4 + "." + value;
          setdot(0);
        }
        if (!isNaN(newValue)) {
          setUnitPrice(newValue);
        }
      }
    }
    // } catch (ex) {}
  };

  const handleToggle = (value) => {
    TimeoutUtility.resetTimeout();
    // setToggle((pre) => !pre);
    setActiveProdMenuId({
      product_id: value.product_id,
      store_id: store_id,
    });
    setActiveProdMenu(true);
    //setproductID(value.product_id);
  };

  const handleAddcartClick = () => {
    TimeoutUtility.resetTimeout();
    // const isProductInCart = CardList.some(
    //   (item) => item.product_id === product.value
    // );

    if (qty <= 0) {
      alert("Quantity should be greater than 0!");
      return;
    } else if (selectedUnit === null) {
      alert("Select Unit!");
      return;
    }
    // if (!isProductInCart && product.value) {
    else if (product.value && userID && userToken) {
      // var supp_id = null;
      // if (supplier_ids !== "" && supplier_ids !== null) {
      //   supp_id = supplier_ids;
      // }
      if (online) {
        let qtyy = qty;
        let upp = unitPrice;
        if (selectedUnit === UnitOptions[1]) {
          qtyy = qty / selectedUnit.conv;
          upp = unitPrice / UnitOptions[0].conv;
        }
        const resp1 = GetProductByIdSale(p_code, store_id, userID, userToken);
        resp1
          .then(function (result) {
            const defaultProduct = {
              product_id: result.data[0].product_id,
              name: result.data[0].name,
              code: result.data[0].code,
              // unit_price: unitPrice / UnitOptions[0].conv,
              unit_price: upp,
              unit: UnitOptions[0].label,
              cost_price: result.data[0].cost_price,
              quantity: qtyy,
              discount: result.data[0].discount,
              total: (unitPrice - result.data[0].discount) * qty,
              shipment: qtyy,
              image: result.data[0].image || null,
              image_url: result.data[0].image_url || null,
              details: result.data[0].details || "",
              req_delivery_date: "",
              supplier_id: supplier_ids,
              supplier_name: supplier_name,
              notes: "",
              spec_qty: 0,
              open_datetime: result.data[0].open_datetime,
            };
            if (CardList.length > 0) {
              setcartList((prevProductList) => [
                defaultProduct,
                ...prevProductList,
              ]);
            } else {
              setcartList([defaultProduct]);
            }
            setProducts("");
            setSelectedProduct("");
            setSelectedSupplier(null);
            setSupplierOptions([]);
            setGetSupplier([]);
            setSelectedUnit("");
            setUnitOptions([]);
            setGetUnit([]);
            setqty(1);
            setUnitPrice(0);
            // setProductOptions((prevOptions) =>
            //   prevOptions.filter(
            //     (option) => option.values !== result.data[0].product_id
            //   )
            // );
          })
          .catch((err) => {
            console.log(err.message);
          });
      } else {
        let qtyy = qty;
        let upp = unitPrice;
        if (selectedUnit === UnitOptions[1]) {
          qtyy = qty / selectedUnit.conv;
          upp = unitPrice / UnitOptions[0].conv;
        }
        const p_id = productOffline.find(
          (item) => item.product_id === product.values
        );
        const defaultProduct = {
          product_id: p_id.product_id,
          name: p_id.productname,
          code: p_id.code,
          unit_price: upp,
          unit: UnitOptions[0].label,
          cost_price: p_id.cost_price,
          quantity: qtyy,
          discount: p_id.discount,
          total: (unitPrice - p_id.discount) * qty,
          // shipment: 0,
          shipment: qtyy,
          image: null,
          image_url: null,
          details: "",
          req_delivery_date: "",
          supplier_id: supplier_ids,
          supplier_name: supplier_name,
          // unit_id: unit_ids,
          // unit_name: unit_name,
          notes: "",
          spec_qty: 0,
          open_datetime: p_id.open_datetime,
        };
        // console.log(defaultProduct);
        if (CardList.length > 0) {
          setcartList((prevProductList) => [
            defaultProduct,
            ...prevProductList,
          ]);
        } else {
          setcartList([defaultProduct]);
        }
        setProducts("");
        setSelectedProduct("");
        setSelectedSupplier(null);
        setSupplierOptions([]);
        setGetSupplier([]);
        setSelectedUnit("");
        setUnitOptions([]);
        setGetUnit([]);
        setqty(1);
        setUnitPrice(0);

        //document.getElementById("product").focus();
      }
      // } else {
      //   setSelectedProduct("");
      //   setSelectedSupplier("");
      //   setSupplierOptions([]);
      //   setqty(1);
      // setUnitPrice(0);
    }
  };

  const handleChangeCustomer = (selectedOption) => {
    TimeoutUtility.resetTimeout();
    if (selectedOption && selectedOption.value) {
      setSelectedCustomer(selectedOption);
      setacc_from_id(selectedOption.account_id);
      setacc_from_bal(selectedOption.balance);
      setc_type_id(selectedOption.type_id);
      if (selectedOption.type_id === 1600) {
        setamount_paid(grandtotal);
        setamount_pend(0);
      } else {
        setamount_paid(0);
        setamount_pend(grandtotal);
      }
      setActiveInput("customer");
      setcustomer_ids(selectedOption.value);
      setcartList([]);
      setProductStr("");
      settotaldiscount(0);
      settotalitem(0);
      setqty(1);
      setUnitPrice(0);
      setSelectedProduct("");
      setSelectedSupplier(null);
      setSupplierOptions([]);
      setSelectedUnit("");
      setUnitOptions([]);
      setnote("");
      settrackingno("");
      setprojectname("");
      setprojectname1("");
      setprojectname2(0);
      setshipmethod("");
    } else {
      setSelectedCustomer(null);
      setacc_from_id("");
      setacc_from_bal("");
      setc_type_id("");
      setamount_paid(0);
      setamount_pend(0);
      setActiveInput("customer");
      setcustomer_ids("");
      setcartList([]);
      setProductStr("");
      settotaldiscount(0);
      settotalitem(0);
      setqty(1);
      setUnitPrice(0);
      setSelectedProduct("");
      setSelectedSupplier(null);
      setSupplierOptions([]);
      setSelectedUnit("");
      setUnitOptions([]);
      setnote("");
      settrackingno("");
      setprojectname("");
      setprojectname1("");
      setprojectname2(0);
      setshipmethod("");
    }
  };

  const handleChangeUnit = (selectedOption) => {
    TimeoutUtility.resetTimeout();
    if (selectedOption && selectedOption.value) {
      if (selectedOption !== selectedUnit) {
        setUnitPrice(unitPrice / selectedOption.conv);
      }
      setSelectedUnit(selectedOption);
      setActiveInput("unit");
      document.getElementById("qty").focus();
    } else {
      // setSelectedUnit(null);
      // setActiveInput("unit");
    }
  };

  const handleChangeUnit1 = (selectedOption, event) => {
    TimeoutUtility.resetTimeout();
    if (event.key === "Enter" && selectedOption && selectedOption.value) {
      if (selectedOption !== selectedUnit) {
        setUnitPrice(unitPrice / selectedOption.conv);
      }
      setSelectedUnit(selectedOption);
      setActiveInput("unit");
      document.getElementById("qty").focus();
    } else {
      // setSelectedUnit(null);
      // setActiveInput("unit");
    }
  };

  const handleChangeSupplier = (selectedOption) => {
    TimeoutUtility.resetTimeout();
    if (selectedOption && selectedOption.value) {
      setSelectedSupplier(selectedOption);
      setActiveInput("supplier");
      setsupplier_ids(selectedOption.value);
      setsupplier_name(selectedOption.label);
    } else {
      setSelectedSupplier(null);
      setActiveInput("supplier");
      setsupplier_ids("");
      setsupplier_name("");
    }
  };

  const handleChangeSupplier1 = (selectedOption, event) => {
    if (event.key === "Enter" && selectedOption && selectedOption.value) {
      setSelectedSupplier(selectedOption);
      setsupplier_ids(selectedOption.value);
      setsupplier_name(selectedOption.label);
      handleAddcartClick();
      document.getElementById("product").focus();
    } else if (event.key === "Enter" && SupplierOptions.length === 0) {
      setSelectedSupplier(null);
      setsupplier_ids("");
      setsupplier_name("");
      handleAddcartClick();
      document.getElementById("product").focus();
    } else {
      setSelectedSupplier(null);
      setActiveInput("supplier");
      setsupplier_ids("");
      setsupplier_name("");
    }
  };

  const handleCopyClick = (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    document.forms[0]["sstreet"].value = document.forms[0]["bstreet"].value;
    document.forms[0]["scity"].value = document.forms[0]["bcity"].value;
    document.forms[0]["sstate"].value = document.forms[0]["bstate"].value;
    document.forms[0]["szip"].value = document.forms[0]["bzip"].value;
    document.forms[0]["sphone"].value = document.forms[0]["bphone1"].value;
    document.forms[0]["scountry"].value = document.forms[0]["bcountry"].value;
  };

  const handleChangeAdvancedMode = (e) => {
    TimeoutUtility.resetTimeout();
    setAdvancedMode((prev) => (prev === 0 ? 1 : 0));
  };

  const handleChangeFullShipping = (e) => {
    TimeoutUtility.resetTimeout();
    setFullShipping((prev) => (prev === 0 ? 1 : 0));
  };

  const handleChangeActive = (e) => {
    TimeoutUtility.resetTimeout();
    if (ActiveProduct !== 0) {
      if (defaultCustomer) {
        setSelectedCustomer(defaultCustomer);
        setacc_from_id(defaultCustomer.account_id);
        setacc_from_bal(defaultCustomer.balance);
        setc_type_id(defaultCustomer.type_id);
        if (defaultCustomer.type_id === 1600) {
          setamount_paid(grandtotal);
          setamount_pend(0);
        } else {
          setamount_paid(0);
          setamount_pend(grandtotal);
        }
        setActiveInput("customer");
        setcustomer_ids(defaultCustomer.value);
      }
    } else {
      setSelectedCustomer(null);
      setacc_from_bal("");
      setamount_paid(0);
      setamount_pend(0);
      setacc_from_id("");
      setcustomer_ids("");
      setcType(getcType[0].name);
      setc_type_id(getcType[0].c_type_id);
    }
    setname("");
    setcartList([]);
    setProductStr("");
    settotaldiscount(0);
    settotalitem(0);
    setSelectedProduct("");
    setSelectedSupplier(null);
    setSupplierOptions([]);
    setSelectedUnit("");
    setUnitOptions([]);
    setqty(1);
    setUnitPrice(0);
    setnote("");
    settrackingno("");
    setprojectname("");
    setprojectname1("");
    setprojectname2(0);
    setshipmethod("");
    setValError([]);
    //setacc_to_bal("");
    //setacc_to_id("");
    setActiveProduct((prev) => (prev === 0 ? 1 : 0));
    document.forms["phone"] = "";
    document.forms["email"] = "";
    document.forms["website"] = "";
    document.forms["opening_balance"] = "";
    document.forms["cname"] = "";
    document.forms["cphone"] = "";
    document.forms["cemail"] = "";
    document.forms["note1"] = "";
    document.forms["bstreet"] = "";
    document.forms["bcity"] = "";
    document.forms["bzip"] = "";
    document.forms["bstate"] = "";
    document.forms["bcountry"] = "";
    document.forms["bphone1"] = "";
    document.forms["bphone2"] = "";
    document.forms["sstreet"] = "";
    document.forms["scity"] = "";
    document.forms["szip"] = "";
    document.forms["sstate"] = "";
    document.forms["scountry"] = "";
    document.forms["sphone"] = "";
    document.forms["sattname"] = "";
  };

  const ValidText1 = (txt, ii) => {
    try {
      const updatedErrors = [...ValError];
      if (txt.trim().length === 0) {
        updatedErrors[ii] = "";
        setValError(updatedErrors);
        return false;
      }
      if (ValidText(txt)) {
        updatedErrors[ii] = "";
        setValError(updatedErrors);
        return true;
      }
      updatedErrors[ii] = "Invalid field!";
      setValError(updatedErrors);
      return false;
    } catch (err) {
      return false;
    }
  };

  const validateEmail1 = (mail, ii) => {
    try {
      const updatedErrors = [...ValError];

      if (mail.trim().length === 0) {
        updatedErrors[ii] = "";
        setValError(updatedErrors);
        return false;
      }
      if (validateEmail(mail)) {
        updatedErrors[ii] = "";
        setValError(updatedErrors);
        return true;
      }
      updatedErrors[ii] = "Invalid field!";
      setValError(updatedErrors);
      return false;
    } catch (err) {
      return false;
    }
  };

  const validPhone1 = (phone, ii) => {
    try {
      const updatedErrors = [...ValError];
      if (phone.trim().length === 0) {
        updatedErrors[ii] = "";
        setValError(updatedErrors);
        return false;
      }
      if (ValidPhone(phone)) {
        updatedErrors[ii] = "";
        setValError(updatedErrors);
        return true;
      }
      updatedErrors[ii] = "Invalid field!";
      setValError(updatedErrors);
      return false;
    } catch (err) {
      return false;
    }
  };

  const ValidWebsite1 = (web, ii) => {
    try {
      const updatedErrors = [...ValError];
      if (web.trim().length === 0) {
        updatedErrors[ii] = "";
        setValError(updatedErrors);
        return false;
      }
      if (ValidWebsite(web)) {
        updatedErrors[ii] = "";
        setValError(updatedErrors);
        return true;
      }
      updatedErrors[ii] = "Invalid field!";
      setValError(updatedErrors);
      return false;
    } catch (err) {
      return false;
    }
  };

  const validName1 = (name, ii) => {
    try {
      const updatedErrors = [...ValError];
      if (name.trim().length === 0) {
        updatedErrors[ii] = "";
        setValError(updatedErrors);
        return false;
      }
      if (validateName(name)) {
        updatedErrors[ii] = "";
        setValError(updatedErrors);
        return true;
      }
      updatedErrors[ii] = "Invalid field!";
      setValError(updatedErrors);
      return false;
    } catch (err) {
      return false;
    }
  };

  const handleChangeName = (e) => {
    TimeoutUtility.resetTimeout();
    setname(e.target.value);
  };

  const handleChangecType = (e) => {
    setcType(e.target.value);
    if (e.target.value !== "select" && e.target.value !== "Select Type") {
      const cType_id = getcType.find((item) => item.name === e.target.value);
      setc_type_id(cType_id.c_type_id);
      const updatedErrors = [...ValError];
      updatedErrors[23] = "";
      setValError(updatedErrors);
    } else {
      const updatedErrors = [...ValError];
      updatedErrors[23] = "Please select Customer Type!";
      setValError(updatedErrors);
    }
  };

  // const handleChangeProduct1 = async (selectedOption, event) => {
  //   if (
  //     event.key === "Enter" &&
  //     selectedOption &&
  //     selectedOption.values &&
  //     userID &&
  //     userToken
  //   ) {
  //     setSelectedProduct(selectedOption);
  //     setqty(1);
  // setUnitPrice(0);
  //     if (!offlineMode) {
  //       await getAllVendorsNameByPurchaseProduct(
  //         selectedOption.values,
  //         userID,
  //         userToken
  //       )
  //         .then((resp) => {
  //           setGetSupplier(resp.data || []);
  //         })
  //         .catch((err) => {
  //           console.log(err.message);
  //         });
  //     } else {
  //       // console.log(selectedOption);
  //     }
  //     setActiveInput("product");
  //     setProducts(selectedOption);
  //     const selectedProduct = selectedOption.values;
  //     setp_code(selectedProduct);
  //     handleAddcartClick();
  //   }
  // };

  const handleChangeProduct = async (selectedOption) => {
    if (selectedOption && selectedOption.values && userID && userToken) {
      var ProductStr1 = ProductStr;
      ProductStr1 = ProductStr1 + selectedOption.values + " ";
      setProductStr(ProductStr1);
      setSelectedProduct(selectedOption);
      setqty(1);
      setUnitPrice(selectedOption.price);
      if (online) {
        await getAllVendorsNameByPurchaseProduct(
          selectedOption.values,
          userID,
          userToken
        )
          .then((resp) => {
            setGetSupplier(resp.data || []);
          })
          .catch((err) => {
            console.log(err.message);
          });
        await GetUnitByProductId(selectedOption.values, userID, userToken)
          .then((resp) => {
            setGetUnit(resp.data || []);
          })
          .catch((err) => {
            console.log(err.message);
          });
      } else {
        const p_id = productOffline.find(
          (item) => item.product_id === selectedOption.values
        );
        const unitt = [
          {
            conv_rate: p_id.conv_rate,
            name: p_id.name,
            names: p_id.names,
            parent: p_id.parent,
            pname: p_id.pname,
            unit_id: p_id.unit_id,
          },
        ];
        setGetUnit(unitt || []);
        var suppps = [];
        if (p_id) {
          if (p_id.Sid1) {
            suppps.push({ vendor_id: p_id.Sid1, vendor: p_id.Supp1 });
          }
          if (p_id.Sid2) {
            suppps.push({ vendor_id: p_id.Sid2, vendor: p_id.Supp2 });
          }
          if (p_id.Sid3) {
            suppps.push({ vendor_id: p_id.Sid3, vendor: p_id.Supp3 });
          }
          if (p_id.Sid4) {
            suppps.push({ vendor_id: p_id.Sid4, vendor: p_id.Supp4 });
          }
          if (p_id.Sid5) {
            suppps.push({ vendor_id: p_id.Sid5, vendor: p_id.Supp5 });
          }
        }
        setGetSupplier(suppps);
      }
      setActiveInput("product");
      setProducts(selectedOption);
      // console.log(selectedOption);
      const selectedProduct = selectedOption.values;
      setp_code(selectedProduct);
      document.getElementById("unit").focus();
    }
  };

  const handleChangeNote = (e) => {
    setnote(e.target.value);
  };

  const handleAccToChange = (e) => {
    setacc_to(e.target.value);
    const acc = getacc_tos?.find((item) => item.name === e.target.value);
    // console.log(acc.account_id);
    setacc_to_bal(acc.end_balance);
    setacc_to_id(acc.account_id);
  };

  const handleChangeProjectName = (e) => {
    setprojectname(e.target.value);
  };

  const handleChangeProjectName1 = (e) => {
    setprojectname1(e.target.value);
  };

  const handleChangeProjectName2 = (e) => {
    setActiveInput("shipment1");
    setprojectname2(e.target.value);
    setindex1(-3);
  };

  const handleChangeAmountPaid = (e) => {
    setActiveInput("amount_paid");
    setamount_paid(e.target.value);
    setamount_pend(grandtotal - e.target.value);
    setindex1(-4);
  };

  const handleChangeTrackingNo = (e) => {
    settrackingno(e.target.value);
  };

  const handleChangeShipMethod = (e) => {
    setshipmethod(e.target.value);
  };

  function truncate(source, size) {
    return source.length > size ? source.slice(0, size - 1) + "…" : source;
  }

  const handleInputChange = (inputValue) => {
    if (customer_ids || ActiveProduct) {
      if (inputValue && inputValue.length >= 2 && userID && userToken) {
        if (online) {
          setProducts("");
          const searchResults = getProductFilterSubString(
            store_id,
            inputValue,
            ProductStr,
            userID,
            userToken
          );
          searchResults
            .then((response) => {
              const productsArray = response.data;
              // const filteredProducts = productsArray.filter(
              //   (product) =>
              //     !CardList.some((item) => item.product_id === product.product_id)
              // );
              //const newProductOptions = filteredProducts.map((item) => ({
              const filteredProducts = productsArray.filter(
                (product) =>
                  new Date(product.open_datetime) <= new Date(oDatetime)
              );
              addProductToOptions(filteredProducts);
            })
            .catch((error) => {
              console.error("Error fetching products:", error);
            });
        } else {
          const productsArray = idbApi.getAllFilterProducts(
            inputValue,
            PRODUCT_TBL
          );
          productsArray.then((response) => {
            const filteredProducts = response.filter(
              (product) =>
                new Date(product.open_datetime) <= new Date(oDatetime) &&
                product.productname
                  .concat(" ", product.code)
                  .toLowerCase()
                  .includes(inputValue.toLowerCase())
            );
            setProductOffline(filteredProducts);
            addProductToOptions(filteredProducts);
          });
        }
      } else {
        setProductOptions([]);
      }
    }
  };

  const addProductToOptions = (prodArr) => {
    const newProductOptions = prodArr.map((item) => ({
      values: item.product_id,
      price: item.unit_price,
      last_so_info:
        "Last Price: " +
        (item.last_price || "-") +
        " - SO#" +
        (item.last_so_id || "-") +
        " - SaleDate: " +
        (item.last_sale_date
          ? new Date(item.last_sale_date).toISOString().split("T")[0]
          : "-"),
      value: online
        ? `${item.code} ${item.productname} ${item.details} ${formatCurrency(
            item.unit_price
          )}`.toLowerCase()
        : `${item.code} ${item.productname} ${formatCurrency(
            item.unit_price
          )}`.toLowerCase(),
      label: (
        <div
          style={{
            display: "flex",
            marginTop: "4px",
          }}
        >
          {online &&
            defaultImageMode &&
            imageMode &&
            (item.image || item.image_url) && (
              <div
                style={{
                  flex: "0 0 10%",
                }}
              >
                <img
                  className="rounded-xl"
                  src={
                    item.image_url
                      ? `${item.image_url}`
                      : `data:image/jpeg;base64,${item.image}`
                  }
                  alt={`Product ${item.code}`}
                  style={{
                    maxWidth: "50px",
                    height: "50px",
                    objectFit: "cover",
                  }}
                />
              </div>
            )}
          <div
            style={{
              flex:
                online &&
                defaultImageMode &&
                imageMode &&
                (item.image || item.image_url)
                  ? "0 0 76%"
                  : "0 0 86%",
              paddingLeft: "0px",
            }}
          >
            <div>
              <div style={{ fontWeight: "bold", fontSize: "16px" }}>{`${
                item.code
              } ${truncate(
                item.productname,
                online &&
                  defaultImageMode &&
                  imageMode &&
                  (item.image || item.image_url)
                  ? 44
                  : 50
              )}`}</div>
            </div>
            {online && (
              <div style={{ fontSize: "14px" }}>{`${truncate(
                item.details,
                online &&
                  defaultImageMode &&
                  imageMode &&
                  (item.image || item.image_url)
                  ? 60
                  : 68
              )}`}</div>
            )}
          </div>
          <div
            style={{
              flex: "0 0 14%",
              fontWeight: "500",
              color: currentColor,
              textAlign: "right",
              verticalAlign: "middle",
              paddingTop: "10px",
              paddingBottom: "10px",
              fontSize: "calc(0.6vw + 4px)",
            }}
          >{`${formatCurrency(item.unit_price)}`}</div>
        </div>
      ),
    }));
    setProductOptions(newProductOptions);
  };

  // const UpdateStatus = async (id) => {
  //   const response = await EditSaleOrderStatus(id);
  //   if (response.status === 200) {
  //     if (response.data[0][0].result === 1) {
  //       alert("Sale order closed successfully.");
  //     } else if (orderstatuslable === "CLOSE") {
  //     } else {
  //       alert("Order failed to close.\nAs order is not completely shipped.");
  //     }
  //   } else {
  //     alert("Failed to update sale order status.");
  //   }
  // };

  const handleSaleOrderClick = async (e) => {
    TimeoutUtility.resetTimeout();
    if (ActiveProduct) {
      const {
        phone,
        email,
        website,
        opening_balance,
        cname,
        cphone,
        cemail,
        note1,
        bstreet,
        bcity,
        bstate,
        bzip,
        bcountry,
        bphone1,
        bphone2,
        sstreet,
        scity,
        sstate,
        szip,
        scountry,
        sattname,
        sphone,
      } = document.forms[0];

      setValError([]);
      const updatedErrors = [...ValError];

      if (name === "") {
        updatedErrors[0] = "Enter Customer Name!";
        setValError(updatedErrors);
        return;
      }
      if (name !== "") {
        if (validName1(name, 0) === false) {
          return;
        }
      }
      var exi = 0;
      await CheckCusNameExist(name, userID, userToken)
        .then((resp) => {
          //console.log(resp.data);
          exi = resp.data[0].name;
        })
        .catch((err) => {
          console.log(err.message);
        });
      if (exi === 1) {
        updatedErrors[0] = "Customer Name must be unique!";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[0] = "";

      if (phone.value === "") {
        updatedErrors[1] = "Enter Phone!";
        setValError(updatedErrors);

        return;
      }
      if (phone.value !== "") {
        if (validPhone1(phone.value, 1) === false) {
          return;
        }
      }
      updatedErrors[1] = "";

      if (email.value !== "") {
        if (validateEmail1(email.value, 2) === false) {
          return;
        }
      }
      updatedErrors[2] = "";

      if (website.value !== "") {
        if (ValidWebsite1(website.value, 3) === false) {
          return;
        }
      }
      updatedErrors[3] = "";

      if (opening_balance.value === "") {
        updatedErrors[4] = "Invalid field!";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[4] = "";

      if (cType === "select" || cType === "Select Type") {
        updatedErrors[23] = "Select Type!";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[23] = "";

      if (cname.value === "") {
        updatedErrors[5] = "Enter Contact Name!";
        setValError(updatedErrors);
        return;
      }
      if (cname.value !== "") {
        if (validName1(cname.value, 5) === false) {
          return;
        }
      }
      updatedErrors[5] = "";

      if (cphone.value !== "") {
        if (validPhone1(cphone.value, 6) === false) {
          return;
        }
      }
      updatedErrors[6] = "";

      if (cemail.value !== "") {
        if (validateEmail1(cemail.value, 7) === false) {
          return;
        }
      }
      updatedErrors[7] = "";

      if (note1.value !== "") {
        if (ValidText1(note1.value, 8) === false) {
          return;
        }
      }
      updatedErrors[8] = "";

      if (bstreet.value !== "") {
        if (ValidText1(bstreet.value, 9) === false) {
          return;
        }
      }
      updatedErrors[9] = "";

      if (bcity.value !== "") {
        if (ValidText1(bcity.value, 10) === false) {
          return;
        }
      }
      updatedErrors[10] = "";

      if (bzip.value !== "") {
        if (ValidText1(bzip.value, 11) === false) {
          return;
        }
      }
      updatedErrors[11] = "";

      if (bstate.value !== "") {
        if (ValidText1(bstate.value, 12) === false) {
          return;
        }
      }
      updatedErrors[12] = "";

      if (bcountry.value !== "") {
        if (ValidText1(bcountry.value, 13) === false) {
          return;
        }
      }
      updatedErrors[13] = "";

      if (bphone1.value !== "") {
        if (validPhone1(bphone1.value, 14) === false) {
          return;
        }
      }
      updatedErrors[14] = "";

      if (bphone2.value !== "") {
        if (validPhone1(bphone2.value, 15) === false) {
          return;
        }
      }
      updatedErrors[15] = "";

      if (sstreet.value !== "") {
        if (ValidText1(sstreet.value, 16) === false) {
          return;
        }
      }
      updatedErrors[16] = "";

      if (scity.value !== "") {
        if (ValidText1(scity.value, 17) === false) {
          return;
        }
      }
      updatedErrors[17] = "";

      if (szip.value !== "") {
        if (ValidText1(szip.value, 18) === false) {
          return;
        }
      }
      updatedErrors[18] = "";

      if (sstate.value !== "") {
        if (ValidText1(sstate.value, 19) === false) {
          return;
        }
      }
      updatedErrors[19] = "";

      if (scountry.value !== "") {
        if (ValidText1(scountry.value, 20) === false) {
          return;
        }
      }
      updatedErrors[20] = "";

      if (sphone.value !== "") {
        if (validPhone1(sphone.value, 21) === false) {
          return;
        }
      }
      updatedErrors[21] = "";

      if (sattname.value !== "") {
        if (validName1(sattname.value, 22) === false) {
          return;
        }
      }
      updatedErrors[22] = "";
      setValError([]);
    } else {
      if (customer_ids === "") {
        alert(`Select a Customer!`);
        return;
      }
    }
    if (acc_to_id === "") {
      alert(`Select Account Received In!`);
      return;
    }
    if (CardList.length === 0) {
      alert("Sales Order cart is empty!");
      return;
    }
    setIsPageFrozen(true);
    setsaveClick(!saveClick);
  };

  const handlePrintOrderClick = async (e) => {
    TimeoutUtility.resetTimeout();
    setprint_flag(true);
    handleSaleOrderClick();
  };

  useEffect(() => {
    async function SaveOrder() {
      if (saveClick && userID && userToken) {
        var cus_id = null,
          acc_fromId = null,
          acc_fromBal = null;
        if (ActiveProduct) {
          const {
            phone,
            email,
            website,
            opening_balance,
            cname,
            cphone,
            cemail,
            note1,
            bstreet,
            bcity,
            bstate,
            bzip,
            bcountry,
            bphone1,
            bphone2,
            sstreet,
            scity,
            sstate,
            szip,
            scountry,
            sattname,
            sphone,
          } = document.forms[0];

          const cType_id = getcType.find((item) => item.name === cType);
          const prof = null;

          const response1 = await AddCustomerApi(
            name,
            phone.value,
            email.value,
            website.value,
            cname.value,
            cphone.value,
            cemail.value,
            prof,
            note1.value,
            bstreet.value,
            bcity.value,
            bstate.value,
            bzip.value,
            bcountry.value,
            bphone1.value,
            bphone2.value,
            sstreet.value,
            scity.value,
            sstate.value,
            szip.value,
            scountry.value,
            sattname.value,
            sphone.value,
            name,
            1100,
            cType_id.c_type_id,
            opening_balance.value,
            store_id,
            userID,
            userToken
          );
          // console.log(response1, "Response");
          if (response1.status === 200) {
            //console.log(response1.data);
            if (response1.data) {
              var aaa = response1.data;
              cus_id = aaa.customer_id;
              acc_fromId = aaa.account_id;
              acc_fromBal = opening_balance.value;
            } else {
              alert("Customer failed to add!");
              setsaveClick(!saveClick);
              setIsPageFrozen(false);
              return;
            }
            // alert("Customer added successfully.");
          } else {
            alert("Customer failed to add!");
            setsaveClick(!saveClick);
            setIsPageFrozen(false);
            return;
          }
        } else {
          cus_id = customer_ids;
          acc_fromId = acc_from_id;
          acc_fromBal = acc_from_bal;
        }

        const updatedFormData = { ...formData };
        updatedFormData.est_sale = "S";
        updatedFormData.customer_id = cus_id;
        updatedFormData.customer_po_no = projectname1;
        updatedFormData.total = grandtotal;
        updatedFormData.amount_pending = grandtotal - amount_paid;
        updatedFormData.amount_paid = amount_paid;
        updatedFormData.so_note = note;
        updatedFormData.total_price = grandtotal;
        updatedFormData.tax = tax;
        updatedFormData.discount = totaldiscount;
        updatedFormData.tracking_no = trackingno;
        updatedFormData.project_name = projectname;
        updatedFormData.ship_method = shipmethod;
        updatedFormData.store_id = store_id;
        updatedFormData.shipment = projectname2;
        updatedFormData.acc_from_id = acc_fromId;
        updatedFormData.acc_to_id = acc_to_id;
        updatedFormData.user_id = userID;
        updatedFormData.acc_from_bal = acc_fromBal;
        if (dTNow) {
          var d = new Date();
          updatedFormData.o_datetime =
            [
              d.getFullYear(),
              (d.getMonth() + 1).toString().padStart(2, "0"),
              d.getDate().toString().padStart(2, "0"),
            ].join("-") +
            " " +
            [
              d.getHours().toString().padStart(2, "0"),
              d.getMinutes().toString().padStart(2, "0"),
              d.getSeconds().toString().padStart(2, "0"),
            ].join(":");
        } else {
          updatedFormData.o_datetime = oDatetime.replace("T", " ");
        }
        updatedFormData.acc_to_bal = acc_to_bal;
        if (OrderStatus === "MARK AS OPEN") {
          updatedFormData.status_id = 81;
        }
        var specOrder = {
          products: [],
        };

        updatedFormData.sale_products = [];
        updatedFormData.shipments = [];
        var ff = 0,
          xx = null;

        const uniqueValues = new Set(
          CardList.map((v) => String(v.product_id) + v.notes)
        );
        if (uniqueValues.size < CardList.length) {
          alert(
            `Duplicate notes for same products found.\nSales Order failed to create.`
          );
          setsaveClick(!saveClick);
          setIsPageFrozen(false);
          return;
        } else {
          CardList.forEach((product) => {
            if (fullShipping === 1) {
              if (
                parseFloat(product.shipment) <= parseFloat(product.quantity)
              ) {
                const shipment = {
                  product_id: product.product_id,
                  s_quantity: product.quantity,
                  quantity_shipped: product.quantity,
                  shipped_note: product.notes,
                };
                updatedFormData.shipments.push(shipment);
              } else {
                if (ff === 0) {
                  xx = product.code;
                  ff = 1;
                }
              }
            } else if (product.shipment > 0) {
              if (
                parseFloat(product.shipment) <= parseFloat(product.quantity)
              ) {
                const shipment = {
                  product_id: product.product_id,
                  s_quantity: product.quantity,
                  quantity_shipped: product.shipment,
                  shipped_note: product.notes,
                };
                updatedFormData.shipments.push(shipment);
              } else {
                if (ff === 0) {
                  xx = product.code;
                  ff = 1;
                }
              }
            }
            var dt = "";
            if (product.req_delivery_date) {
              dt = product.req_delivery_date.replace("T", " ");
            }
            const saleProduct = {
              product_id: product.product_id,
              supplier_id: product.supplier_id,
              quantity: product.quantity,
              cost_price: product.cost_price,
              price: product.unit_price,
              discount: product.discount,
              req_delivery_date: dt,
              item_note: product.notes,
            };
            updatedFormData.sale_products.push(saleProduct);
          });

          if (ff === 1) {
            alert(
              `Ship qty of ${xx} must be less or equal to total qty.\nSales Order failed to create.`
            );
            setsaveClick(!saveClick);
            setIsPageFrozen(false);
            return;
          }
          ff = 0;
          CardList.forEach((product, index) => {
            if (parseFloat(product.spec_qty) > 0) {
              if (
                parseFloat(product.spec_qty) <= parseFloat(product.quantity)
              ) {
              } else {
                if (ff === 0) {
                  xx = product.code;
                  ff = 1;
                }
              }
            }
          });
          if (ff === 1) {
            alert(
              `Special order qty of ${xx} must be less or equal to total qty.\nSales Order failed to create.`
            );
            setsaveClick(!saveClick);
            setIsPageFrozen(false);
            return;
          }
          setFormData(updatedFormData);
          var so_idd = null;

          if (online) {
            const response = await AddSaleOrderApi(
              updatedFormData,
              userID,
              userToken
            );
            if (response.status === 200) {
              so_idd = response.data.so_id;
              //console.log(so_idd);

              if (print_flag && so_idd && store_id && userToken && userID) {
                //await openNewTab(so_idd);
                const res1 = await GetGenerateInvoice(
                  store_id,
                  so_idd,
                  "New",
                  userID,
                  userToken
                );
                if (res1.data) {
                  const pdfBlob = new Blob([res1.data], {
                    type: "application/pdf",
                  });
                  const pdfURL = URL.createObjectURL(pdfBlob);
                  const newWindow = window.open(pdfURL);
                  // if (pdfURL) {
                  //   const link = document.createElement("a");
                  //   link.href = pdfURL;
                  //   link.download = `SaleInvoice # S${so_id}.pdf`;
                  //   link.click();
                  // }
                  if (newWindow) {
                    // Wait for PDF to load, then print
                    newWindow.addEventListener("load", () => {
                      newWindow.focus();
                      newWindow.print();
                    });
                  }
                }
                alert("Sales order added successfully.");
                setprint_flag(false);
              } else {
                alert("Sales order added successfully.");
              }
            } else {
              alert("Sales order failed to add!");
              setsaveClick(!saveClick);
              setIsPageFrozen(false);
              return;
            }
          } else {
            await idbApi.add(updatedFormData, PENDSALES_TBL);
            if (print_flag && store_id && userToken && userID) {
              const iii = await generateInvoice(
                "00000",
                cus_id,
                storeG.name,
                userName,
                orgName,
                "Offline",
                updatedFormData.o_datetime,
                updatedFormData.project_name,
                updatedFormData.ship_method,
                updatedFormData.shipment,
                updatedFormData.so_note,
                updatedFormData.tax,
                updatedFormData.total_price,
                updatedFormData.sale_products
              );
              const pdfBlob = new Blob([iii], {
                type: "application/pdf",
              });
              const pdfURL = URL.createObjectURL(pdfBlob);
              const newWindow = window.open(pdfURL);
              if (newWindow) {
                // Wait for PDF to load, then print
                newWindow.addEventListener("load", () => {
                  newWindow.focus();
                  newWindow.print();
                });
              }
              alert("Sales order added successfully in Offline Mode.");
              setprint_flag(false);
            } else {
              alert("Sales order added successfully in Offline Mode.");
            }
          }
          CardList.forEach((product, index) => {
            var qq = 10;
            if (parseFloat(product.spec_qty) > 0) {
              //console.log("1");
              if (
                parseFloat(product.spec_qty) <= parseFloat(product.quantity)
              ) {
                //console.log("12");
                if (product.shipment > 0) {
                  if (
                    parseFloat(product.shipment) <= parseFloat(product.quantity)
                  ) {
                    if (
                      parseFloat(product.shipment) >=
                      parseFloat(product.spec_qty)
                    ) {
                      qq = 13;
                    }
                  }
                }
                const Specproduct = {
                  product_id: product.product_id,
                  so_id: so_idd,
                  quantity_req: product.spec_qty,
                  item_note: product.notes,
                  quantity_order: 0,
                  status_id: qq,
                  note: "",
                };
                specOrder.products.push(Specproduct);
              } else {
                if (ff === 0) {
                  xx = product.code;
                  ff = 1;
                }
              }
            }
          });

          if (specOrder.products.length > 0) {
            if (online) {
              const resp = await AddSpecialOrder(specOrder, userID, userToken);
              if (resp.status === 200) {
                // console.log(resp.data);
                if (resp.data.id) {
                } else {
                  setsaveClick(!saveClick);
                  setIsPageFrozen(false);
                  alert("Special qty failed to add!");
                  return;
                }
              } else {
                alert("Special qty failed to add!");
                setsaveClick(!saveClick);
                setIsPageFrozen(false);
                return;
              }
            } else {
              alert("Special qty failed to add in Offline Mode!");
              setsaveClick(!saveClick);
              setIsPageFrozen(false);
              return;
            }
          }

          setsaveClick(!saveClick);
          setIsPageFrozen(false);
          window.location.reload();
        }
      }
    }
    SaveOrder();
    // eslint-disable-next-line
  }, [saveClick]);

  const handleNewClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    try {
      const path = `/Sales/AddSaleOrder/${store_id}`;
      window.open([path], "_blank");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleStatusClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    if (CardList.length === 0) {
      alert("Sales order cart is empty.");
      return;
    }
    if (orderstatuslable === "CLOSE") {
      // if (window.confirm(`Order is already closed.\nStill want to continue?`)) {
      setOrderStatus("MARK AS CLOSE");
      setorderstatuslable("OPEN");
      return;
      // } else {
      // return;
      // }
    } else if (orderstatuslable === "OPEN") {
      let f = 0;
      CardList.forEach((element) => {
        if (!(parseInt(element.quantity) <= parseInt(element.shipment))) {
          f = 1;
        } else {
          setOrderStatus("MARK AS OPEN");
          setorderstatuslable("CLOSE");
          return;
        }
      });
      if (f === 1) {
        if (
          window.confirm(
            `Quantity is not completely shipped.\nStill want to continue?`
          )
        ) {
          setOrderStatus("MARK AS OPEN");
          setorderstatuslable("CLOSE");
          return;
        }
      }
    }
  };

  const handleClearClick = async (event) => {
    TimeoutUtility.resetTimeout();
    if (window.confirm(`Are you sure you want to Clear the sale order?`)) {
      window.location.reload();
    }
  };

  const handleBackClick = async (event) => {
    TimeoutUtility.resetTimeout();
    if (
      window.confirm(
        `Are you sure you want to Close without saving the changes?`
      )
    ) {
      window.close();
    }
  };

  const CalculateAllFields = () => {
    let total_amt = 0,
      total_itm = 0;
    let total_dis = 0;
    let grandTotal = 0.0;
    let taxx = 0,
      dd = 0;

    if (tax) {
      taxx = parseFloat(tax);
    }
    if (projectname2) {
      dd = parseFloat(projectname2);
    }

    for (let i = 0; i < CardList.length; i++) {
      let a = 0,
        b = 0,
        c = 0;
      if (CardList[i].total) {
        a = parseFloat(CardList[i].total);
      }
      if (CardList[i].discount) {
        b = parseFloat(CardList[i].discount);
      }
      if (CardList[i].quantity) {
        c = parseFloat(CardList[i].quantity);
      }
      total_amt = total_amt + a + b * c;
      total_dis = total_dis + b * c;
      total_itm = total_itm + c;
    }
    settotaldiscount(total_dis);
    settotalAmount(total_amt);
    settotalitem(total_itm);

    taxx = (taxx / 100) * (total_amt - total_dis);
    grandTotal = total_amt - total_dis + taxx + dd;

    setgrandtotal(grandTotal);
    if (c_type_id === 1600) {
      setamount_paid(grandTotal);
      setamount_pend(0);
    } else {
      setamount_paid(0);
      setamount_pend(grandTotal);
    }
  };

  const handleNotesChange = (index, value) => {
    const newCartList = [...CardList];
    newCartList[index].notes = value;
    setcartList(newCartList);
    setActiveInput("notes");
    setindex1(index);
  };

  const handleQuantityChange = (index, value) => {
    const newCartList = [...CardList];
    if (!ValidOrderField(value)) {
      if (value !== "") {
        newCartList[index].quantity = 0;
        newCartList[index].total =
          value * parseFloat(newCartList[index].unit_price) -
          value * parseFloat(newCartList[index].discount);
        newCartList[index].shipment = 0;
        setcartList(newCartList);
        setActiveInput("quantity");
        setindex1(index);
        return;
      }
    } else {
      newCartList[index].quantity = value;
      newCartList[index].shipment = value;
      newCartList[index].total =
        value * parseFloat(newCartList[index].unit_price) -
        value * parseFloat(newCartList[index].discount);
      setcartList(newCartList);
      setActiveInput("quantity");
      setindex1(index);
    }
  };

  const handleUnitPriceChange = (index, value) => {
    const newCartList = [...CardList];
    newCartList[index].unit_price = value;
    newCartList[index].total =
      value * parseFloat(newCartList[index].quantity) -
      parseFloat(newCartList[index].quantity) *
        parseFloat(newCartList[index].discount);
    setcartList(newCartList);
    setActiveInput("unit_price");
    setindex1(index);
  };

  const handleSpecQtyChange = (index, value) => {
    const newCartList = [...CardList];
    newCartList[index].spec_qty = value;
    setcartList(newCartList);
    setActiveInput("spec_qty");
    setindex1(index);
  };

  const handleShipmentChange = (index, value) => {
    const newCartList = [...CardList];
    newCartList[index].shipment = value;
    setcartList(newCartList);
    setActiveInput("shipment");
    setindex1(index);
  };

  const handleDiscountChange = (index, value) => {
    const newCartList = [...CardList];
    newCartList[index].discount = value;
    newCartList[index].total =
      (parseFloat(newCartList[index].unit_price) - value) *
      parseFloat(newCartList[index].quantity);
    setcartList(newCartList);
    setActiveInput("discount");
    setindex1(index);
  };

  const handleChangeTax = (e) => {
    setActiveInput("tax");
    settax(e.target.value);
    setindex1(-2);
  };

  const handleChangeQty = (e) => {
    setActiveInput("qty");
    setqty(e.target.value);
  };

  const handleEnterQty = (e) => {
    if (e.key === "Enter") {
      document.getElementById("uprice").focus();
    }
  };

  const handleChangeUPrice = (e) => {
    setActiveInput("uprice");
    setUnitPrice(e.target.value);
  };

  const handleEnterUPrice = (e) => {
    if (e.key === "Enter") {
      document.getElementById("supplier").focus();
    }
  };

  const formatCurrency = (number) => {
    return number.toLocaleString("en-PK", {
      style: "currency",
      currency: "PKR",
      minimumFractionDigits: 2,
    });
  };

  const handleDeleteClick = (index) => {
    TimeoutUtility.resetTimeout();
    const removedProduct = CardList[index];
    if (
      window.confirm(`Do you want to remove ${removedProduct.code} from cart?`)
    ) {
      const item1 = CardList[index].product_id;
      const newCartList = [...CardList];
      newCartList.splice(index, 1);
      setcartList(newCartList);

      const currentIdsArray = ProductStr.split(" ");
      const updatedIdsArray = currentIdsArray.filter(
        (id) => id !== String(item1)
      );
      const updatedProductIds = updatedIdsArray.join(" ");
      setProductStr(updatedProductIds);
    }
  };

  useEffect(() => {
    setGetSupplier([]);
    setGetUnit([]);
    setProducts("");
    setp_code("");
    setqty(1);
    setUnitPrice(0);
    setSelectedProduct(null);
    setProductOptions([]);
    if (dTNow === 0) {
      if (GetCustomer.length > 0) {
        var d1 = new Date(oDatetime);
        const filteredCustomers = GetCustomer.filter(
          (item) => new Date(item.open_datetime) <= d1
        );
        const fetchedCustomerOption = filteredCustomers.map((item) => ({
          label: `${item.customer}`,
          value: item.customer_id,
          balance: item.balance,
          account_id: item.account_id,
          type_id: item.type_id,
          o_datetime: item.open_datetime,
        }));
        setCustomerOptions(fetchedCustomerOption);
        if (fetchedCustomerOption.length > 0) {
          setDefaultCustomer(fetchedCustomerOption[0]);
          setSelectedCustomer(fetchedCustomerOption[0]);
          if (fetchedCustomerOption[0]) {
            setActiveInput("customer");
            setcustomer_ids(fetchedCustomerOption[0].value);
            setacc_from_bal(fetchedCustomerOption[0].balance);
            setacc_from_id(fetchedCustomerOption[0].account_id);
            setc_type_id(fetchedCustomerOption[0].type_id);
          }
        } else {
          setDefaultCustomer(null);
          setSelectedCustomer(null);
          setcustomer_ids("");
          setacc_from_bal("");
          setacc_from_id("");
          setc_type_id("");
        }
      }
      if (allAccTo.length > 0) {
        const filteredAccTos = allAccTo.filter(
          (item) => new Date(item.open_datetime) <= new Date(oDatetime)
        );
        setGetacc_tos(filteredAccTos);
      }
      if (CardList.length > 0) {
        const filteredCart = CardList.filter(
          (product) => new Date(product.open_datetime) <= new Date(oDatetime)
        );
        if (filteredCart !== CardList) {
          setcartList(filteredCart);
        }
      }
    } else {
      if (GetCustomer.length > 0) {
        const fetchedCustomerOption = GetCustomer.map((item) => ({
          label: `${item.customer}`,
          value: item.customer_id,
          balance: item.balance,
          account_id: item.account_id,
          type_id: item.type_id,
          o_datetime: item.open_datetime,
        }));
        setCustomerOptions(fetchedCustomerOption);
        if (fetchedCustomerOption.length > 0) {
          setDefaultCustomer(fetchedCustomerOption[0]);
          setSelectedCustomer(fetchedCustomerOption[0]);
          if (fetchedCustomerOption[0]) {
            setActiveInput("customer");
            setcustomer_ids(fetchedCustomerOption[0].value);
            setacc_from_bal(fetchedCustomerOption[0].balance);
            setacc_from_id(fetchedCustomerOption[0].account_id);
            setc_type_id(fetchedCustomerOption[0].type_id);
            //getCustomerDetail(fetchedCustomerOption[0].value);
          }
        } else {
          setDefaultCustomer(null);
          setSelectedCustomer(null);
          setcustomer_ids("");
          setacc_from_bal("");
          setacc_from_id("");
          setc_type_id("");
        }
      }
      if (allAccTo.length > 0) {
        const filteredAccTos = allAccTo.filter(
          (item) => new Date(item.open_datetime) <= new Date(oDatetime)
        );
        setGetacc_tos(filteredAccTos);
      }
    }
  }, [oDatetime]);

  useEffect(() => {
    async function fetchData() {
      try {
        if (getacc_tos.length > 0) {
          setacc_to(getacc_tos[0]);
          var bal = getacc_tos[0];
          setacc_to_id(bal.account_id);
          setacc_to_bal(bal.end_balance);
        } else {
          setacc_to("");
          setacc_to_id("");
          setacc_to_bal("");
        }
        //console.log(bal.end_balance);
      } catch (err) {}
    }
    fetchData();
  }, [getacc_tos]);

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    async function fetchData() {
      if (store_id && userID && userToken && online !== null) {
        if (GetCustomer.length > 0) {
          if (!online) {
            alert(
              `Your System is Offline now.\n\nThis page will reload to get into Offline Mode!`
            );
            window.location.reload();
          }
        }
        var now = new Date();
        now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
        setODatetime(now.toISOString().slice(0, 19));
        var sto_id = store_id;
        if (!online) {
          setGetCustomer(await idbApi.getAllNow(CUSTOMER_TBL));
          setAllAccTo(await idbApi.getAllNow(ACCOUNTREC_TBL));
          setGetacc_tos(await idbApi.getAllNow(ACCOUNTREC_TBL));
          settax(0);
        } else {
          if (store_id >= 5000000) {
            await GetSaleOrderCustomerByID(store_id, userID, userToken)
              .then((resp) => {
                sto_id = resp.data[0].store_id;
                setDup(resp.data[0].customer_id);
                setprojectname(resp.data[0].project_name);
                setnote(resp.data[0].so_note);
                setprojectname2(resp.data[0].shipment);
                setacc_from_id(resp.data[0].account_id);
              })
              .catch((err) => {
                console.log(err.message);
              });
            await GetSaleOrderDetailsByID(store_id, userID, userToken).then(
              function (result) {
                if (result.data) {
                  const productList = result.data.map((item) => {
                    return {
                      product_id: item.product_id,
                      name: item.product_name,
                      code: item.code,
                      unit_price: item.unit_price,
                      unit: item.unit,
                      cost_price: item.cost_price,
                      quantity: item.quantity,
                      discount: item.discount,
                      total: (item.unit_price - item.discount) * item.quantity,
                      shipment: item.quantity,
                      image: item.image,
                      image_url: item.image_url,
                      details: item.details,
                      notes: item.item_note,
                      req_delivery_date: "",
                      supplier_id: item.vendor_id,
                      supplier_name: item.vendor,
                      spec_qty: 0,
                      open_datetime: item.open_datetime,
                    };
                  });
                  setcartList(() => [...productList]);
                }
              }
            );

            setStore_id(sto_id);
          }
          await getAccNamesAssetCash(sto_id, userID, userToken)
            .then((resp) => {
              if (resp?.data?.length >= 0) {
                setAllAccTo(resp.data || []);
                setGetacc_tos(resp.data || []);
                idbApi.deleteAll(ACCOUNTREC_TBL);
                idbApi.addList(resp.data, ACCOUNTREC_TBL);
              } else {
                setAllAccTo(idbApi.getAllNow(ACCOUNTREC_TBL));
                setGetacc_tos(idbApi.getAllNow(ACCOUNTREC_TBL));
              }
            })
            .catch((err) => {
              setAllAccTo(idbApi.getAllNow(ACCOUNTREC_TBL));
              setGetacc_tos(idbApi.getAllNow(ACCOUNTREC_TBL));
              console.log(err.message);
            });

          await GetAllCustomersName(sto_id, userID, userToken)
            .then((resp) => {
              if (resp?.data?.length >= 0) {
                setGetCustomer(resp.data || []);
                idbApi.deleteAll(CUSTOMER_TBL);
                idbApi.addList(resp.data, CUSTOMER_TBL);
              } else {
                setGetCustomer(idbApi.getAllNow(CUSTOMER_TBL));
              }
            })
            .catch((err) => {
              setGetCustomer(idbApi.getAllNow(CUSTOMER_TBL));
              console.log(err.message);
            });

          await GetAllCustomerTypes(userID, userToken)
            .then((resp) => {
              setGetcType(resp.data || []);
            })
            .catch((err) => {
              console.log(err.message);
            });

          await GetTaxByStoreId(sto_id, userID, userToken)
            .then((resp) => {
              if (resp?.data?.length >= 0) {
                settax(resp.data[0].tax);
              } else {
                settax(0);
              }
            })
            .catch((err) => {
              settax(0);
              console.log(err.message);
            });
          await getProductsAddSOOffline(sto_id, userID, userToken)
            .then((resp) => {
              if (resp?.data?.length >= 0) {
                idbApi.deleteAll(PRODUCT_TBL);
                idbApi.addList(resp.data, PRODUCT_TBL);
              }
            })
            .catch((err) => {
              console.log(err.message);
            });
        }
      }
    }
    fetchData();
  }, [store_id, userID, userToken, online]);

  const customFilter = (option, inputValue) => {
    const optionSearchField = String(option.value).toLowerCase();
    const lowerCasedInput = inputValue.toLowerCase();
    return optionSearchField.includes(lowerCasedInput);
  };

  useEffect(() => {
    const fetchCustomerOptions = async () => {
      if (GetCustomer?.length > 0) {
        const fetchedCustomerOption = GetCustomer.map((item) => ({
          label: `${item.customer}`,
          value: item.customer_id,
          balance: item.balance,
          account_id: item.account_id,
          type_id: item.type_id,
        }));
        if (CustomerOptions.length === 0) {
          setCustomerOptions(fetchedCustomerOption);
          setDefaultCustomer(fetchedCustomerOption[0]);
        }
        if (!dup || dup === "") {
          setSelectedCustomer(fetchedCustomerOption[0]);
          if (fetchedCustomerOption[0]) {
            setacc_from_id(fetchedCustomerOption[0].account_id);
            setacc_from_bal(fetchedCustomerOption[0].balance);
            setc_type_id(fetchedCustomerOption[0].type_id);
            setActiveInput("customer");
            setcustomer_ids(fetchedCustomerOption[0].value);
            // console.log(fetchedCustomerOption[0]);
            //getCustomerDetail(fetchedCustomerOption[0].value);
          }
        } else {
          var cus_ind = fetchedCustomerOption.findIndex((p) => p.value === dup);
          if (fetchedCustomerOption[cus_ind]) {
            setSelectedCustomer(fetchedCustomerOption[cus_ind]);
            setacc_from_id(fetchedCustomerOption[cus_ind].account_id);
            setacc_from_bal(fetchedCustomerOption[cus_ind].balance);
            setc_type_id(fetchedCustomerOption[cus_ind].type_id);
            // console.log(fetchedCustomerOption[cus_ind]);
            setActiveInput("customer");
            setcustomer_ids(fetchedCustomerOption[cus_ind].value);
            //getCustomerDetail(fetchedCustomerOption[0].value);
          }
        }
      }
      //setcartList([]);
    };
    fetchCustomerOptions();
  }, [GetCustomer, dup]);

  useEffect(() => {
    const fetchSupplierOptions = async () => {
      if (GetSupplier) {
        const fetchedSupplierOption = GetSupplier.map((item) => ({
          label: `${item.vendor}`,
          value: item.vendor_id,
        }));
        setSupplierOptions(fetchedSupplierOption);
        if (fetchedSupplierOption[0]) {
          setSelectedSupplier(fetchedSupplierOption[0]);
          setsupplier_ids(fetchedSupplierOption[0].value);
          setsupplier_name(fetchedSupplierOption[0].label);
        } else {
          setSelectedSupplier(null);
          setsupplier_ids("");
          setsupplier_name("");
        }
      }
    };
    fetchSupplierOptions();
  }, [GetSupplier]);

  useEffect(() => {
    const fetchUnitOptions = async () => {
      if (GetUnit && GetUnit.length > 0) {
        const fetchedOption = [];
        fetchedOption.push({
          label: `${GetUnit[0].name}`,
          value: GetUnit[0].unit_id,
          conv: parseFloat(GetUnit[0].conv_rate),
        });
        if (GetUnit[0].parent) {
          fetchedOption.push({
            label: `${GetUnit[0].pname}`,
            value: GetUnit[0].parent,
            conv: 1 / parseFloat(GetUnit[0].conv_rate),
          });
        }
        setUnitOptions(fetchedOption);
        if (fetchedOption[0]) {
          setSelectedUnit(fetchedOption[0]);
        }
      }
    };
    fetchUnitOptions();
  }, [GetUnit]);

  useEffect(() => {
    CalculateAllFields();
  }, [CardList, tax, projectname2]);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      maxHeight: "70px",
      height: "70px",
      fontSize: "14px",
    }),
    option: (provided) => ({
      ...provided,
      maxHeight: "70px",
      fontSize: "14px",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "250px",
    }),
  };

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 bg-white rounded-3xl">
      {isPageFrozen && <div className="overlay-freeze" />}
      <Container fluid className="g-0 p-0 justify-end">
        <Row
          xs={1}
          sm={1}
          className="justify-content-center"
          style={{ padding: "0" }}
        >
          <Col md={7} className="container-col">
            <Header title="CREATE SALES ORDER" />
          </Col>
          <Col md={2} className="container-col">
            <label className="label" style={{ fontSize: "12px" }}>
              <span style={{ paddingLeft: "8px", paddingRight: "36px" }}>
                DateTime:
              </span>
              <span>
                Now{" "}
                <input
                  type="checkbox"
                  checked={dTNow === 1}
                  onChange={handleChangeDTNow}
                  style={{ width: "14px", height: "14px" }}
                />
              </span>
            </label>
            <input
              disabled={dTNow}
              className="input"
              id="o_date"
              type="datetime-local"
              style={{
                textAlign: "left",
                fontSize: "12px",
                width: "178px",
                background: dTNow && "lightgray",
              }}
              value={oDatetime}
              min={oMinDatetime}
              max={oMaxDatetime}
              onChange={(e) => handleChangeODateTime(e.target.value)}
            />
          </Col>
          <Col md={3} className="container-col">
            <label
              style={{
                marginLeft: "32px",
                fontWeight: "bold",
                fontSize: "18px",
                backgroundColor: currentColor,
                color: "white",
                padding: "4px",
                paddingLeft: "8px",
                paddingRight: "8px",
                borderRadius: "5px",
              }}
            >
              ORDER STATUS: {orderstatuslable}
            </label>
          </Col>
        </Row>
        <Row
          xs={1}
          sm={1}
          className="justify-content-center"
          style={{ padding: "0" }}
        >
          <Col md={9} className="container-col">
            <div className="card-sale">
              <Row
                xs={1}
                sm={1}
                className="justify-content-center"
                style={{ padding: "0" }}
              >
                <Col md={12} className="container-col">
                  <Row>
                    <Col md={10}>
                      <label
                        className="label"
                        htmlFor="customer"
                        style={{ fontSize: "18px" }}
                      >
                        Customer:
                      </label>
                    </Col>
                    {online && (
                      <Col md={2}>
                        <label className="label" style={{ fontSize: "13px" }}>
                          <input
                            type="checkbox"
                            value="ActiveProduct"
                            checked={ActiveProduct === 1}
                            onChange={handleChangeActive}
                          />
                          {` `}New Customer
                        </label>
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>

              {ActiveProduct && online ? (
                <form>
                  <Row>
                    <Col md={3}>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <input
                            className="input"
                            required
                            type="text"
                            name="name"
                            value={name}
                            onChange={handleChangeName}
                            placeholder="Name"
                            autoFocus
                            onBlur={(e) => validName1(e.target.value, 0)}
                            style={{
                              width: "calc(100% - 12px)",
                              height: "10%",
                              fontSize: "12px",
                            }}
                          />
                          <span className="label-imp">*</span>
                          {ValError[0] && (
                            <p className="label-error-pos">{ValError[0]}</p>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col md={2}>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <input
                            required
                            type="text"
                            name="phone"
                            placeholder="Phone"
                            className="input"
                            onBlur={(e) => validPhone1(e.target.value, 1)}
                            style={{
                              width: "calc(100% - 12px)",
                              height: "10%",
                              fontSize: "12px",
                            }}
                          />
                          <span className="label-imp">*</span>
                          {ValError[1] && (
                            <p className="label-error-pos">{ValError[1]}</p>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col md={2}>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <input
                            type="text"
                            name="email"
                            placeholder="Email"
                            className="input"
                            onChange={(e) => validateEmail(e.target.value)}
                            onBlur={(e) => validateEmail1(e.target.value, 2)}
                            style={{
                              width: "calc(100% - 12px)",
                              height: "10%",
                              fontSize: "12px",
                            }}
                          />
                          {ValError[2] && (
                            <p className="label-error-pos">{ValError[2]}</p>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col md={2}>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <input
                            type="text"
                            name="website"
                            placeholder="Website"
                            className="input"
                            onBlur={(e) => ValidWebsite1(e.target.value, 3)}
                            style={{
                              height: "110%",
                              width: "calc(100% - 12px)",
                              fontSize: "12px",
                            }}
                          />
                          {ValError[3] && (
                            <p className="label-error-pos">{ValError[3]}</p>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col md={1}>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <input
                            type="number"
                            step="1.00"
                            min="0"
                            name="opening_balance"
                            placeholder="Open Bal"
                            className="input"
                            style={{
                              width: "calc(100% - 12px)",
                              height: "10%",
                              fontSize: "12px",
                            }}
                          />
                          <span className="label-imp">*</span>
                          {ValError[4] && (
                            <p className="label-error-pos">{ValError[4]}</p>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col md={2}>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <select
                            className="select"
                            id="cTypeSelect"
                            value={cType}
                            onChange={handleChangecType}
                            style={{
                              margin: "0px",
                              width: "calc(100% - 12px)",
                              height: "110%",
                              fontSize: "12px",
                              padding: "8px",
                            }}
                          >
                            {getcType.map((item) => (
                              <option key={item.c_type_id}>{item.name}</option>
                            ))}
                          </select>
                          <span className="label-imp">*</span>
                          {ValError[23] && (
                            <p className="label-error-pos">{ValError[23]}</p>
                          )}
                        </div>
                      </div>
                    </Col>

                    <Col md={3}>
                      <div className="col-lg-12 mt-2">
                        <div className="form-group">
                          <input
                            className="input"
                            type="text"
                            name="cname"
                            placeholder="Contact Name"
                            onBlur={(e) => validName1(e.target.value, 5)}
                            style={{
                              width: "calc(100% - 12px)",
                              height: "10%",
                              fontSize: "12px",
                            }}
                          />
                          <span className="label-imp">*</span>
                          {ValError[5] && (
                            <p className="label-error-pos">{ValError[5]}</p>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col md={2}>
                      <div className="col-lg-12 mt-2">
                        <div className="form-group">
                          <input
                            type="text"
                            name="cphone"
                            placeholder="Contact Phone"
                            className="input"
                            onBlur={(e) => validPhone1(e.target.value, 6)}
                            style={{
                              width: "calc(100% - 12px)",
                              height: "10%",
                              fontSize: "12px",
                            }}
                          />
                          {ValError[6] && (
                            <p className="label-error-pos">{ValError[6]}</p>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col md={2}>
                      <div className="col-lg-12 mt-2">
                        <div className="form-group">
                          <input
                            type="text"
                            name="cemail"
                            placeholder="Contact Email"
                            className="input"
                            onBlur={(e) => validateEmail1(e.target.value, 7)}
                            style={{
                              width: "calc(100% - 12px)",
                              height: "10%",
                              fontSize: "12px",
                            }}
                          />
                          {ValError[7] && (
                            <p className="label-error-pos">{ValError[7]}</p>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col md={5}>
                      <div className="col-lg-12 mt-2">
                        <div className="form-group">
                          <input
                            className="input"
                            type="text"
                            name="note1"
                            placeholder="Note"
                            onBlur={(e) => ValidText1(e.target.value, 8)}
                            style={{
                              width: "calc(100% - 12px)",
                              height: "10%",
                              fontSize: "12px",
                            }}
                          />
                          {ValError[8] && (
                            <p className="label-error-pos">{ValError[8]}</p>
                          )}
                        </div>
                      </div>
                    </Col>

                    <Col md={2}>
                      <div className="col-lg-12 mt-2">
                        <div className="form-group">
                          <input
                            className="input"
                            type="text"
                            name="bstreet"
                            placeholder="Billing Street"
                            onBlur={(e) => ValidText1(e.target.value, 9)}
                            style={{
                              width: "calc(100% - 12px)",
                              height: "10%",
                              fontSize: "12px",
                            }}
                          />
                          {ValError[9] && (
                            <p className="label-error-pos">{ValError[9]}</p>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col md={1}>
                      <div className="col-lg-12 mt-2">
                        <div className="form-group">
                          <input
                            className="input"
                            type="text"
                            name="bcity"
                            placeholder="Billing City"
                            onBlur={(e) => ValidText1(e.target.value, 10)}
                            style={{
                              width: "calc(100% - 12px)",
                              height: "10%",
                              fontSize: "12px",
                            }}
                          />
                          {ValError[10] && (
                            <p className="label-error-pos">{ValError[10]}</p>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col md={2}>
                      <div className="col-lg-12 mt-2">
                        <div className="form-group">
                          <input
                            className="input"
                            type="text"
                            name="bstate"
                            placeholder="Billing State"
                            onBlur={(e) => ValidText1(e.target.value, 12)}
                            style={{
                              width: "calc(100% - 12px)",
                              height: "10%",
                              fontSize: "12px",
                            }}
                          />
                          {ValError[12] && (
                            <p className="label-error-pos">{ValError[12]}</p>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col md={1}>
                      <div className="col-lg-12 mt-2">
                        <div className="form-group">
                          <input
                            className="input"
                            type="text"
                            name="bzip"
                            placeholder="Billing Zip"
                            onBlur={(e) => ValidText1(e.target.value, 11)}
                            style={{
                              width: "calc(100% - 12px)",
                              height: "10%",
                              fontSize: "12px",
                            }}
                          />
                          {ValError[11] && (
                            <p className="label-error-pos">{ValError[11]}</p>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col md={2}>
                      <div className="col-lg-12 mt-2">
                        <div className="form-group">
                          <input
                            className="input"
                            type="text"
                            name="bcountry"
                            placeholder="Billing Country"
                            onBlur={(e) => ValidText1(e.target.value, 13)}
                            style={{
                              width: "calc(100% - 12px)",
                              height: "10%",
                              fontSize: "12px",
                            }}
                          />
                          {ValError[13] && (
                            <p className="label-error-pos">{ValError[13]}</p>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col md={2}>
                      <div className="col-lg-12 mt-2">
                        <div className="form-group">
                          <input
                            className="input"
                            type="text"
                            name="bphone1"
                            placeholder="Billing Phone 1"
                            onBlur={(e) => validPhone1(e.target.value, 14)}
                            style={{
                              width: "calc(100% - 12px)",
                              height: "10%",
                              fontSize: "12px",
                            }}
                          />
                          {ValError[14] && (
                            <p className="label-error-pos">{ValError[14]}</p>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col md={2}>
                      <div className="article-container-cus1">
                        <div className="article-cu3">
                          <div className="col-lg-12 mt-2">
                            <div className="form-group">
                              <input
                                className="input"
                                type="text"
                                name="bphone2"
                                placeholder="Billing Phone 2"
                                onBlur={(e) => validPhone1(e.target.value, 15)}
                                style={{
                                  width: "calc(100% - 12px)",
                                  height: "10%",
                                  fontSize: "12px",
                                }}
                              />
                              {ValError[15] && (
                                <p className="label-error-pos">
                                  {ValError[15]}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                        <div
                          className="article-cu2"
                          style={{
                            marginTop: "6px",
                            alignContent: "center",
                          }}
                        >
                          <button
                            style={{
                              fontSize: "12px",
                              padding: "4px",
                              backgroundColor: currentColor,
                              color: "#fff",
                              border: "none",
                              fontWeight: "bold",
                              width: "24px",
                              borderRadius: "4px",
                            }}
                            color="white"
                            onClick={handleCopyClick}
                          >
                            C
                          </button>
                        </div>
                      </div>
                    </Col>

                    <Col md={2}>
                      <div className="col-lg-12 mt-2">
                        <div className="form-group">
                          <input
                            className="input"
                            type="text"
                            name="sstreet"
                            placeholder="Shipping Street"
                            onBlur={(e) => ValidText1(e.target.value, 16)}
                            style={{
                              width: "calc(100% - 12px)",
                              height: "10%",
                              fontSize: "12px",
                            }}
                          />
                          {ValError[16] && (
                            <p className="label-error-pos">{ValError[16]}</p>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col md={1}>
                      <div className="col-lg-12 mt-2">
                        <div className="form-group">
                          <input
                            className="input"
                            type="text"
                            name="scity"
                            placeholder="Ship City"
                            onBlur={(e) => ValidText1(e.target.value, 17)}
                            style={{
                              width: "calc(100% - 12px)",
                              height: "10%",
                              fontSize: "12px",
                            }}
                          />
                          {ValError[17] && (
                            <p className="label-error-pos">{ValError[17]}</p>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col md={2}>
                      <div className="col-lg-12 mt-2">
                        <div className="form-group">
                          <input
                            className="input"
                            type="text"
                            name="sstate"
                            placeholder="Shipping State"
                            onBlur={(e) => ValidText1(e.target.value, 19)}
                            style={{
                              width: "calc(100% - 12px)",
                              height: "10%",
                              fontSize: "12px",
                            }}
                          />
                          {ValError[19] && (
                            <p className="label-error-pos">{ValError[19]}</p>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col md={1}>
                      <div className="col-lg-12 mt-2">
                        <div className="form-group">
                          <input
                            className="input"
                            type="text"
                            name="szip"
                            placeholder="Ship Zip"
                            onBlur={(e) => ValidText1(e.target.value, 18)}
                            style={{
                              width: "calc(100% - 12px)",
                              height: "10%",
                              fontSize: "12px",
                            }}
                          />
                          {ValError[18] && (
                            <p className="label-error-pos">{ValError[18]}</p>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col md={2}>
                      <div className="col-lg-12 mt-2">
                        <div className="form-group">
                          <input
                            className="input"
                            type="text"
                            name="scountry"
                            placeholder="Shipping Country"
                            onBlur={(e) => ValidText1(e.target.value, 20)}
                            style={{
                              width: "calc(100% - 12px)",
                              height: "10%",
                              fontSize: "12px",
                            }}
                          />
                          {ValError[20] && (
                            <p className="label-error-pos">{ValError[20]}</p>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col md={2}>
                      <div className="col-lg-12 mt-2">
                        <div className="form-group">
                          <input
                            className="input"
                            type="text"
                            name="sphone"
                            placeholder="Shipping Phone"
                            onBlur={(e) => validPhone1(e.target.value, 21)}
                            style={{
                              width: "calc(100% - 12px)",
                              height: "10%",
                              fontSize: "12px",
                            }}
                          />
                          {ValError[21] && (
                            <p className="label-error-pos">{ValError[21]}</p>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col md={2}>
                      <div className="col-lg-12 mt-2">
                        <div className="form-group">
                          <input
                            className="input"
                            type="text"
                            name="sattname"
                            placeholder="Shipping Attention Name"
                            onBlur={(e) => validName1(e.target.value, 22)}
                            style={{
                              width: "calc(100% - 12px)",
                              height: "10%",
                              fontSize: "12px",
                            }}
                          />
                          {ValError[22] && (
                            <p className="label-error-pos">{ValError[22]}</p>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </form>
              ) : (
                <>
                  <Row
                    xs={1}
                    sm={1}
                    className="justify-content-center"
                    style={{ padding: "0" }}
                  >
                    <Col md={12} className="container-col">
                      <div className="sale-input-div">
                        <div className="sale-input">
                          <Select
                            className="myreact-select"
                            inputId="customer"
                            value={selectedCustomer}
                            onChange={handleChangeCustomer}
                            options={CustomerOptions}
                            isSearchable
                            placeholder="Select Customer"
                            isClearable={true}
                          />
                        </div>

                        <div
                          className="sale-bal ml-4"
                          style={{ backgroundColor: currentColor }}
                        >
                          <label>{formatCurrency(acc_from_bal)}</label>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </>
              )}
              <div
                style={{
                  marginTop: ValError.every((element) => element === "")
                    ? "20px"
                    : "12px",
                }}
              />
              <Row
                xs={1}
                sm={1}
                className="justify-content-center"
                style={{ padding: "0" }}
              >
                <Col md={12} className="container-col">
                  <div style={{ display: "flex" }}>
                    <label
                      htmlFor="product"
                      className="label"
                      style={{ fontSize: "18px", flex: "46%" }}
                    >
                      Product:
                    </label>
                    <label
                      className="label"
                      style={{ fontSize: "18px", flex: "11%" }}
                    >
                      Unit:
                    </label>
                    <label
                      className="label"
                      style={{ fontSize: "18px", flex: "8.5%" }}
                    >
                      Quantity:
                    </label>
                    <label
                      className="label"
                      style={{ fontSize: "18px", flex: "8.5%" }}
                    >
                      Price:
                    </label>
                    <label
                      className="label"
                      style={{ fontSize: "18px", flex: "26%" }}
                    >
                      Supplier:
                    </label>
                  </div>
                  <div className="sale-input-div">
                    <div className="sale-input">
                      <Select
                        className="myreact-select-prod"
                        inputId="product"
                        menuPlacement="bottom"
                        menuPosition="fixed"
                        value={selectedProduct}
                        onChange={handleChangeProduct}
                        options={productOptions}
                        isSearchable
                        placeholder="Search Product With Name / Code"
                        autoFocus
                        styles={customStyles}
                        // onKeyDown={(event) =>
                        //   handleChangeProduct1(selectedProduct, event)
                        // }
                        filterOption={customFilter}
                        onInputChange={handleInputChange}
                      />
                      <Select
                        className="myreact-select-unit"
                        inputId="unit"
                        menuPlacement="bottom"
                        menuPosition="fixed"
                        value={selectedUnit}
                        onChange={handleChangeUnit}
                        options={UnitOptions}
                        isSearchable
                        placeholder="Unit"
                        styles={customStyles}
                        onKeyDown={(event) =>
                          handleChangeUnit1(selectedUnit, event)
                        }
                      />
                      <input
                        id="qty"
                        type="number"
                        step="1"
                        min="0"
                        max="1000000"
                        className="input myreact-select-prod-qty"
                        value={qty}
                        placeholder="Quantity"
                        onClick={() => handleInputClick("qty", -8)}
                        onChange={handleChangeQty}
                        onKeyDown={handleEnterQty}
                      />
                      <input
                        id="uprice"
                        type="number"
                        step="1"
                        min="0"
                        max="1000000"
                        className="input myreact-select-prod-price"
                        value={unitPrice}
                        placeholder="Unit Price"
                        onClick={() => handleInputClick("uprice", -9)}
                        onChange={handleChangeUPrice}
                        onKeyDown={handleEnterUPrice}
                      />
                      <Select
                        className="myreact-select-supp"
                        inputId="supplier"
                        menuPlacement="bottom"
                        menuPosition="fixed"
                        value={selectedSupplier}
                        onChange={handleChangeSupplier}
                        options={SupplierOptions}
                        isSearchable
                        placeholder="Product Supplier"
                        isClearable
                        styles={customStyles}
                        onKeyDown={(event) =>
                          handleChangeSupplier1(selectedSupplier, event)
                        }
                      />
                    </div>
                    <button
                      className="sale-bal ml-4"
                      type="button"
                      style={{
                        backgroundColor: currentColor,
                        fontWeight: "1000",
                        fontSize: "18px",
                        height: "100%",
                      }}
                      onClick={handleAddcartClick}
                    >
                      +{/* ➕ */}
                    </button>
                  </div>
                </Col>
              </Row>
              <br />
              <Row className="container-col">
                <Col md={8} className="mt-1 right-table-field">
                  <label className="pl-4">
                    {selectedProduct?.last_so_info}
                  </label>
                </Col>
                <Col md={2}>
                  <label className="mt-2 label" style={{ fontSize: "14px" }}>
                    <input
                      type="checkbox"
                      value="advancedMode"
                      checked={fullShipping === 1}
                      onChange={handleChangeFullShipping}
                    />
                    {` `}Full Shipment
                  </label>
                </Col>
                {/* {online && (
                  <Col md={2}>
                    <label className="mt-2 label" style={{ fontSize: "14px" }}>
                      <input
                        type="checkbox"
                        value="advancedMode"
                        checked={advancedMode === 1}
                        onChange={handleChangeAdvancedMode}
                      />
                      {` `}Advanced Mode
                    </label>
                  </Col>
                )} */}
              </Row>
              <Row
                xs={1}
                sm={1}
                className="justify-content-center table-container-sale"
                style={{ height: ActiveProduct ? "34vh" : "44vh" }}
              >
                <div className="m-0 p-0">
                  <table className="table table-striped table-bordered">
                    <thead>
                      <tr className="table-sale-tr">
                        <th style={{ width: "80px" }}>CODE</th>
                        <th style={{ width: "280px" }}>PRODUCT</th>
                        <th style={{ width: "60px" }}>UNIT</th>
                        <th style={{ width: "65px" }}>QTY</th>
                        <th style={{ width: "80px" }}>PRICE</th>
                        <th style={{ width: "75px" }}>DISC</th>
                        <th style={{ width: "75px" }}>TOTAL</th>
                        <th style={{ width: "110px" }}>REQ DATE</th>
                        {advancedMode === 1 && (
                          <>
                            <th style={{ width: "90px" }}>SUPPLIER</th>
                            <th style={{ width: "65px" }}>SHIP QTY</th>
                            <th style={{ width: "60px" }}>SPC QTY</th>
                          </>
                        )}
                        <th style={{ width: "180px" }}>NOTES</th>
                        <th style={{ width: "35px" }}>DEL</th>
                      </tr>
                    </thead>
                    <tbody className="pos-table-body">
                      {CardList?.map((item, index) => (
                        <tr key={index}>
                          <td onClick={() => handleToggle(item)}>
                            {item.code}
                          </td>
                          <td onClick={() => handleToggle(item)}>
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                              {defaultImageMode &&
                                imageMode &&
                                (item.image || item.image_url) && (
                                  <div
                                    className="image flex gap-4"
                                    style={{
                                      maxWidth: "72px",
                                      height: "72px",
                                      flex: "0 0 20%",
                                    }}
                                  >
                                    <img
                                      className="rounded-xl"
                                      src={
                                        item.image_url
                                          ? `${item.image_url}`
                                          : `data:image/jpeg;base64,${item.image}`
                                      }
                                      alt={`Product ${item.code}`}
                                    />
                                  </div>
                                )}
                              <div
                                style={{
                                  flex:
                                    defaultImageMode &&
                                    imageMode &&
                                    (item.image || item.image_url)
                                      ? "0 0 80%"
                                      : "0 0 100%",
                                  paddingTop:
                                    !(
                                      defaultImageMode &&
                                      imageMode &&
                                      (item.image || item.image_url)
                                    ) && "8px",
                                  paddingBottom:
                                    !(
                                      defaultImageMode &&
                                      imageMode &&
                                      (item.image || item.image_url)
                                    ) && "7px",
                                  alignSelf: "center",
                                }}
                              >
                                <div style={{ fontWeight: "bold" }}>
                                  {truncate(
                                    item.name,
                                    defaultImageMode &&
                                      imageMode &&
                                      (item.image || item.image_url)
                                      ? 38
                                      : 44
                                  )}
                                </div>
                                <div>
                                  {truncate(
                                    item.details,
                                    defaultImageMode &&
                                      imageMode &&
                                      (item.image || item.image_url)
                                      ? 78
                                      : 88
                                  )}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td>{item.unit}</td>
                          <td>
                            <div className="centered-input">
                              <input
                                className="input"
                                id="quantity"
                                type="number"
                                step="1.00"
                                min="0"
                                value={item.quantity}
                                onClick={() =>
                                  handleInputClick("quantity", index)
                                }
                                onChange={(e) =>
                                  handleQuantityChange(index, e.target.value)
                                }
                              />
                            </div>
                          </td>
                          <td>
                            <div className="centered-input">
                              <input
                                className="input"
                                id="unit_price"
                                type="number"
                                step="1.00"
                                min="0"
                                value={item.unit_price}
                                onClick={() =>
                                  handleInputClick("unit_price", index)
                                }
                                onChange={(e) =>
                                  handleUnitPriceChange(index, e.target.value)
                                }
                              />
                            </div>
                          </td>
                          <td>
                            <div className="centered-input">
                              <input
                                className="input"
                                id="discount"
                                min="0"
                                max={item.unit_price}
                                type="number"
                                step="1.00"
                                value={item.discount}
                                onClick={() =>
                                  handleInputClick("discount", index)
                                }
                                onChange={(e) =>
                                  handleDiscountChange(index, e.target.value)
                                }
                              />
                            </div>
                          </td>
                          <td>{formatCurrency(item.total)}</td>
                          <td>
                            <div className="centered-input">
                              <input
                                className="input"
                                id="req_date"
                                type="datetime-local"
                                value={item.req_delivery_date}
                                onChange={(e) =>
                                  handleChangeReqDate(index, e.target.value)
                                }
                              />
                            </div>
                          </td>
                          {advancedMode === 1 && (
                            <>
                              <td>{item.supplier_name}</td>
                              <td>
                                <div className="centered-input">
                                  <input
                                    className="input"
                                    id="shipment"
                                    type="number"
                                    min="0"
                                    max={item.quantity}
                                    step="1.00"
                                    value={item.shipment}
                                    disabled={fullShipping === 1}
                                    onClick={() =>
                                      handleShipmentClick("shipment", index)
                                    }
                                    onChange={(e) =>
                                      handleShipmentChange(
                                        index,
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="centered-input">
                                  <input
                                    className="input"
                                    id="spec_order"
                                    type="number"
                                    min="0"
                                    max={item.quantity}
                                    step="1.00"
                                    value={item.spec_qty}
                                    onClick={() =>
                                      handleSpecQtyClick("spec_qty", index)
                                    }
                                    onChange={(e) =>
                                      handleSpecQtyChange(index, e.target.value)
                                    }
                                  />
                                </div>
                              </td>
                            </>
                          )}
                          <td>
                            <div className="centered-input">
                              <textarea
                                className="textarea"
                                id="notes"
                                type="text"
                                maxLength={250}
                                value={item.notes}
                                onClick={() => handleInputClick("notes", index)}
                                onChange={(e) =>
                                  handleNotesChange(index, e.target.value)
                                }
                              />
                            </div>
                          </td>
                          <td>
                            <button onClick={() => handleDeleteClick(index)}>
                              ❌
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Row>
              <Row
                xs={1}
                sm={1}
                className="justify-content-center table-container-sale1"
              >
                <table className="borderless w-100 h-100">
                  <tbody>
                    <tr>
                      <td
                        className="table-sum-label"
                        style={{ paddingTop: "8px" }}
                      >
                        SUB TOTAL:
                      </td>
                      <td
                        className="table-sum-cash"
                        style={{ color: currentColor, paddingTop: "8px" }}
                      >
                        {formatCurrency(total_amount)}
                      </td>
                      <td
                        className="table-grand-sum"
                        rowSpan="8"
                        style={{ backgroundColor: currentColor }}
                      >
                        <div className="tgs-label">
                          BALANCE DUE
                          <br />
                          <span className="tgs-value">
                            {formatCurrency(amount_pend)}
                          </span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="table-sum-label">DISCOUNT:</td>
                      <td
                        className="table-sum-cash"
                        style={{ color: currentColor }}
                      >
                        {formatCurrency(totaldiscount)}
                      </td>
                    </tr>
                    <tr>
                      <td className="table-sum-label">TAX:</td>
                      <td className="table-sum-cash">
                        <label style={{ color: currentColor }}>{"%"}</label>
                        <input
                          id="tax"
                          type="number"
                          step="1"
                          min="0"
                          max="100"
                          className="input table-sum-tb"
                          value={tax}
                          onClick={() => handleInputClick("tax", -2)}
                          onChange={handleChangeTax}
                          style={{ color: currentColor }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td className="table-sum-label">SHIPPING:</td>
                      <td className="table-sum-cash">
                        <label style={{ color: currentColor }}>{"$"}</label>
                        <input
                          type="number"
                          name="shipment"
                          min="0"
                          step="1.00"
                          value={projectname2}
                          onChange={handleChangeProjectName2}
                          onClick={() => handleInputClick("shipment1", -3)}
                          className="input table-sum-tb"
                          style={{ marginLeft: "13px", color: currentColor }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td className="table-sum-label">AMOUNT PAID:</td>
                      <td className="table-sum-cash">
                        <label style={{ color: currentColor }}>{"$"}</label>
                        <input
                          type="number"
                          name="amount_paid"
                          min="0"
                          step="1.00"
                          disabled={c_type_id === 1600 ? true : false}
                          value={amount_paid}
                          onChange={handleChangeAmountPaid}
                          onClick={() => handleInputClick("amount_paid", -4)}
                          className="input table-sum-tb"
                          style={{
                            marginLeft: "13px",
                            color: currentColor,
                            background: c_type_id === 1600 && "lightgray",
                          }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td className="table-sum-label">RECEIVED IN:</td>
                      <td className="table-sum-cash">
                        <select
                          className="select table-sum-tb"
                          style={{ color: currentColor, marginLeft: "22px" }}
                          value={acc_to}
                          onChange={handleAccToChange}
                        >
                          {getacc_tos.length > 0 &&
                            getacc_tos?.map((item) => (
                              <option key={item.account_id}>{item.name}</option>
                            ))}
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td className="table-sum-label">GRAND TOTAL:</td>
                      <td
                        className="table-sum-cash"
                        style={{ color: currentColor }}
                      >
                        {formatCurrency(grandtotal)}
                      </td>
                    </tr>
                    <tr>
                      <td
                        className="table-sum-label"
                        style={{ marginBottom: "8px" }}
                      >
                        TOTAL ITEMS:
                      </td>
                      <td
                        className="table-sum-cash"
                        style={{ color: currentColor, marginBottom: "8px" }}
                      >
                        {total_item || 0}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Row>
            </div>
          </Col>
          <Col md={3} className="container-col">
            <div className="card-sale">
              <Row
                xs={1}
                sm={1}
                className="justify-content-center"
                style={{ padding: "0px" }}
              >
                <Col
                  md={6}
                  className="container-col"
                  style={{ paddingRight: "5px", paddingBottom: "10px" }}
                >
                  <Card
                    className="action-btns-card"
                    style={{ background: saveClick ? "gray" : currentColor }}
                    onClick={handleSaleOrderClick}
                    //disabled={saveClick}
                  >
                    <div className="action-btn">SAVE</div>
                  </Card>
                </Col>
                <Col
                  md={6}
                  className="container-col"
                  style={{ paddingLeft: "5px", paddingBottom: "10px" }}
                >
                  <Card
                    className="action-btns-card"
                    style={{ background: currentColor }}
                    onClick={handlePrintOrderClick}
                  >
                    <div className="action-btn">SAVE & PRINT</div>
                  </Card>
                </Col>
              </Row>
              <Row
                xs={1}
                sm={1}
                className="justify-content-center"
                style={{ padding: "0px" }}
              >
                <Col
                  md={6}
                  className="container-col"
                  style={{ paddingRight: "5px", paddingBottom: "10px" }}
                >
                  <Card
                    className="action-btns-card"
                    style={{ background: currentColor }}
                    onClick={handleNewClick}
                  >
                    <div className="action-btn">NEW</div>
                  </Card>
                </Col>
                <Col
                  md={6}
                  className="container-col"
                  style={{ paddingLeft: "5px", paddingBottom: "10px" }}
                >
                  <Card
                    className="action-btns-card"
                    style={{ background: currentColor }}
                    onClick={handleClearClick}
                  >
                    <div className="action-btn">CLEAR</div>
                  </Card>
                </Col>
              </Row>
              <Row
                xs={1}
                sm={1}
                className="justify-content-center"
                style={{ padding: "0px" }}
              >
                <Col
                  md={6}
                  className="container-col"
                  style={{ paddingRight: "5px", paddingBottom: "10px" }}
                >
                  <Card
                    className="action-btns-card"
                    style={{ background: currentColor }}
                    onClick={handleStatusClick}
                  >
                    <div className="action-btn">{OrderStatus}</div>
                  </Card>
                </Col>
                <Col
                  md={6}
                  className="container-col"
                  style={{ paddingLeft: "5px", paddingBottom: "10px" }}
                >
                  <Card
                    className="action-btns-card"
                    style={{ background: currentColor }}
                    onClick={handleBackClick}
                  >
                    <div className="action-btn">EXIT</div>
                  </Card>
                </Col>
              </Row>
              <Row
                xs={1}
                sm={1}
                className="justify-content-center"
                style={{ paddingLeft: "16px", paddingRight: "16px" }}
              >
                <Col md={6} className="container-col right-table-field">
                  <label>Ship Method:</label>
                  <input
                    type="text"
                    name="shipmethod"
                    placeholder="Ship-Method"
                    value={shipmethod}
                    onChange={handleChangeShipMethod}
                    className="input"
                  />
                </Col>
                <Col md={6} className="container-col right-table-field">
                  <label>Tracking No:</label>
                  <input
                    type="text"
                    name="tracking_no"
                    value={trackingno}
                    onChange={handleChangeTrackingNo}
                    placeholder="Tracking No."
                    className="input"
                  />
                </Col>
                <Col md={6} className="container-col right-table-field">
                  <label>Contact:</label>
                  <input
                    type="text"
                    name="project name"
                    value={projectname}
                    onChange={handleChangeProjectName}
                    placeholder="Contact"
                    className="input"
                  />
                </Col>
                <Col md={6} className="container-col right-table-field">
                  <label>Customer PO:</label>
                  <input
                    type="text"
                    name="Customer_po"
                    value={projectname1}
                    onChange={handleChangeProjectName1}
                    placeholder="Customer PO"
                    className="input"
                  />
                </Col>
                <Col
                  md={12}
                  className="container-col right-table-field"
                  style={{ paddingTop: "4px", paddingBottom: "16px" }}
                >
                  <textarea
                    placeholder="Sales Order Note"
                    id="noteTextarea"
                    value={note}
                    onChange={handleChangeNote}
                    className="textarea"
                  />
                </Col>
              </Row>
              <Row
                xs={1}
                sm={1}
                className="justify-content-center"
                style={{ padding: "0px" }}
              >
                {keypadButtons.map((number, index) => (
                  <Col md={4} className="container-col" key={index}>
                    <Card
                      className="keypad-button1"
                      style={{
                        border: "1px solid " + currentColor,
                        color: currentColor,
                      }}
                      key={number}
                      onClick={() => handleKeypadClick(number)}
                    >
                      {number}
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
          {/* {toggle && (
            <div className="overlay1">
              <Sidebar
                close={() => setToggle(false)}
                product_id={productID}
                store_id={store_id}
              />
            </div>
          )} */}
        </Row>
      </Container>
    </div>
  );
};
export default AddSaleOrder;
